<template>
    <div class="dbRootPanel" ref="dashBoardPanelRef">
        <!-- 头部模块 -->
        <header>
            <h1 @click="dialogInfo.opening = true" title="打开项目详情" style="cursor: pointer;">
                <span>黑龙江省水利水电集团</span>
            </h1>
            <div class="imagePanel">
                <img src="../assets/favlogo.png" alt="">
            </div>
            <p><span>HEILONGJIANG PROVINCE WATER RESOURCES AND HYDROPOWER GROUP</span></p>
            <!-- 当前时间 -->
            <div class="dateNowPanel">{{ dateNow }}</div>
            <!-- 业务系统 -->
            <div class="yeWuWebSite" title="业务管理系统" @click="pushToOtherWebSiteHandler('业务管理系统', true)">
                <img src="../assets/齿轮.svg" alt="">
            </div>
            <!-- 退出系统按钮 -->
            <div class="quitBtn" @click="quitOutWebsiteHandler">退出</div>
        </header>

        <!-- 中心核心模块容器 -->
        <div class="main">
            <!-- 7大类项目类型 -->
            <div class="top5">
                <div class="top5-title">
                    <span>中标项目分类</span>
                </div>
                <div class="top5-content">
                    <ul ref="colorRepeatListPanelRef">
                        <li v-for="item in projectTypeList" :key="item.id">
                            <div class="cicle" :style="`${activeStyleText(item.id, 'cicle')}`">
                            </div>
                            <div title="点击查看详细数据" class="li-content"
                                :style="`${activeStyleText(item.id, 'content')};cursor:pointer;`"
                                @click="showDialog(true, '中标项目分类')">
                                <span
                                    :style="`color:${activeItemId === item.id ? '#ea9700' : '#ffffff'};font-size:${activeItemId === item.id ? '0.8rem' : ''};font-weight:${activeItemId === item.id ? '600' : '500'};`">{{
                                        item.label }}</span>
                                <span>{{ item.value }}</span>
                                <span>
                                    <img :src="upImage" alt="您的浏览器不支持此图片">
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="top5-title" style="display:none;">
                    <span>区域项目建设情况</span>
                </div>
            </div>

            <!-- 获奖统计 -->
            <div class="awardInfoPanel" ref="awardInfoPanelRef"></div>

            <!-- 中心区域(智慧树) -->
            <div class="total" ref="totalPanelRef">
                <div class="data1">
                    <span>合同订单总额(年度/万元)</span>
                    <!-- <p>1,010,559</p> -->
                    <p>{{ totalAmountInfo.IND_000001 }}</p>
                </div>
                <div class="data2">
                    <span>营业收入总额(年度/万元)</span>
                    <p>{{ totalAmountInfo.IND_000002 }}</p>
                </div>
                <div title="点击查看详细数据" style="cursor: pointer;" class="data3" @click="showDialog(true, '完成产值总额')">
                    <span>完成产值总额(年度/万元)</span>
                    <p>{{ totalAmountInfo.IND_000003 }}</p>
                </div>
                <div class="data4">
                    <span>利润总额(年度/万元)</span>
                    <p>{{ totalAmountInfo.IND_000004 }}</p>
                </div>
                <canvas class="dashed" ref="dashedCanvasRef"></canvas>
                <div class="sphere">
                    <!-- <div class="sphere-bg"></div> -->
                    <!-- <div class="sum">
                        <span>销售总额</span>
                        <p>568971401</p>
                    </div> -->
                    <video autoplay ref="mVideoRef">
                        <source src="../assets/video/video.webm" type="video/webm">
                    </video>
                </div>
                <div class="cicle3"></div>
                <!-- <div class="cicle4"></div>
                <div class="cicle5"></div>
                <div class="cicle6"></div>
                <div class="cicle7"></div> -->
                <div class="cicle8" ref="appleKeChuangRef" @click="pushToOtherWebSiteHandler('科创管理驾驶舱', true)">
                    <span>科&nbsp;创</span>
                    <span>驾驶舱</span>
                </div>
                <div class="cicle9" ref="appleJingYingRef" @click="pushToOtherWebSiteHandler('经营管理驾驶舱', true)">
                    <span>经&nbsp;营</span>
                    <span>驾驶舱</span>
                </div>
                <div class="cicle10" ref="appleZiYuanRef" @click="pushToOtherWebSiteHandler('人力管理驾驶舱', true)">
                    <span>人&nbsp;力</span>
                    <span>驾驶舱</span>
                </div>
                <div class="cicle11" ref="appleAnQuanRef" @click="pushToOtherWebSiteHandler('安全管理驾驶舱', true)">
                    <span>管&nbsp;控</span>
                    <span>驾驶舱</span>
                </div>
            </div>

            <!-- 年度目标 -->
            <div class="analyse">
                <div class="analyse-title" v-if="false">
                    <span>快捷导航</span>
                </div>
                <div class="websiteMenu">
                    <div>
                        <div @click="pushToOtherWebSiteHandler('党辉企航', true)">
                            <img src="../assets/yeWuGuanLi.svg" alt="">
                            <span>党辉企航</span>
                        </div>
                        <div @click="pushToOtherWebSiteHandler('智慧工地', true)">
                            <img src="../assets/zhiHuiGongDi.svg" alt="">
                            <span>智慧工地</span>
                        </div>
                    </div>
                    <div>
                        <div @click="pushToOtherWebSiteHandler('智慧农业', true)">
                            <img src="../assets/zhiHuiNongYe.svg" alt="">
                            <span>智慧农业</span>
                        </div>
                        <div @click="pushToOtherWebSiteHandler('数智工坊', true)">
                            <img src="../assets/shuZhiShuiLi.svg" alt="">
                            <span>数智工坊</span>
                        </div>
                    </div>
                </div>
                <!-- 水利水电集团发展理念 -->
                <div class="waterEleIdeaPanel">
                    <p>集团管理理念</p>
                    <div v-if="avtiveDreamItem === 'FIRST'" class="dreamPanel">
                        <div @click="openDreamDialogHandler(1)">
                            <span>&quot;3 + 3 + 6&quot;&nbsp;战略布局</span>
                            <div class="imgLogoPanel"></div>
                        </div>
                        <div @click="openDreamDialogHandler(2)">
                            <span>&quot;1641&quot;&nbsp;工程</span>
                            <div class="imgLogoPanel"></div>
                        </div>
                        <div @click="openDreamDialogHandler(5)">
                            <span>&quot;一委四心&quot;&nbsp;组织理念</span>
                            <div class="imgLogoPanel"></div>
                        </div>
                        <div @click="openDreamDialogHandler(8)">
                            <span>&quot;12345&quot;&nbsp;项目管理思路</span>
                            <div class="imgLogoPanel"></div>
                        </div>
                    </div>

                    <div v-else class="dreamPanel">
                        <div @click="openDreamDialogHandler(3)">
                            <span>&quot;是毋追求&quot;&nbsp;发展理念</span>
                            <div class="imgLogoPanel"></div>
                        </div>
                        <div @click="openDreamDialogHandler(6)">
                            <span>&quot;九四管理&quot;&nbsp;施工理念</span>
                            <div class="imgLogoPanel"></div>
                        </div>
                        <div @click="openDreamDialogHandler(7)">
                            <span>&quot;一核四全及三力一孔&quot;&nbsp;用人理念</span>
                            <div class="imgLogoPanel"></div>
                        </div>
                        <div @click="openDreamDialogHandler(4)">
                            <span>&quot;六共六合&quot;&nbsp;经营理念</span>
                            <div class="imgLogoPanel"></div>
                        </div>
                    </div>
                    <div class="changeButtons">
                        <div @click="avtiveDreamItem = 'FIRST'"
                            :style="`background-color:${avtiveDreamItem === 'FIRST' ? '#03a9f480' : ''}`"></div>
                        <div @click="avtiveDreamItem = 'SECOND'"
                            :style="`background-color:${avtiveDreamItem === 'SECOND' ? '#03a9f480' : ''}`"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部模块名称容器 -->
        <div class="bottom">
            <!-- <h5><span>智慧树看板</span></h5>
            <p>Tree Of Knowledge</p> -->

            <!-- 八大平台 -->
            <div @click="pushToOtherWebSiteHandler('科创管理')">
                <img src="../assets/keChuangGuanLi.svg" alt="">
                <span>科创管理</span>
                <div class="borderPanel"></div>
            </div>
            <div @click="pushToOtherWebSiteHandler('人力管理')">
                <img src="../assets/shuiLiFangZhou.svg" alt="">
                <span>人力管理</span>
                <div class="borderPanel"></div>
            </div>
            <div @click="pushToOtherWebSiteHandler('智慧采购', true)">
                <img src="../assets/zhiHuiCaiGou.svg" alt="">
                <span>智慧采购</span>
                <div class="borderPanel"></div>
            </div>
            <div @click="pushToOtherWebSiteHandler('OA办公', true)">
                <img src="../assets/oaBanGong.svg" alt="">
                <span>OA办公</span>
                <div class="borderPanel"></div>
            </div>
            <div @click="pushToOtherWebSiteHandler('机物料联')">
                <img src="../assets/ziYuanGuanLi.svg" alt="">
                <span>机物料联</span>
                <div class="borderPanel"></div>
            </div>
            <div @click="pushToOtherWebSiteHandler('资料整编')">
                <img src="../assets/zhiLiangGuanLi.svg" alt="">
                <span>资料整编</span>
                <div class="borderPanel"></div>
            </div>
            <div @click="pushToOtherWebSiteHandler('安全管理')">
                <img src="../assets/anQuanGuanLi.svg" alt="">
                <span>数据管控</span>
                <div class="borderPanel"></div>
            </div>
            <div @click="pushToOtherWebSiteHandler('ERP管理')">
                <img src="../assets/erp.svg" alt="">
                <span>ERP管理</span>
                <div class="borderPanel"></div>
            </div>
        </div>

        <!-- 弹窗 -->
        <div class="dialogWindow" ref="dialogWindowRef" @click="showDialog(false)">
            <!-- 实际存放内容的主体 -->
            <div class="dialogWindowBody">
                <!-- 背景 -->
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="869.020263671875" height="303.0001220703125" viewBox="0 0 869.020263671875 303.0001220703125"
                    fill="none" preserveAspectRatio="none">
                    <path
                        d="M861.973 267.361L862.999 38.1025L842.051 19L28.9475 19L8 42.2909L8 284.086L20.996 302L204.479 300.5L219.185 287.001L827.516 287.001L827.516 290.057L842.051 290.057L861.973 267.361Z"
                        fill="#03111C" fill-opacity="0">
                    </path>
                    <path
                        d="M845.651 13.9872L865.746 36.2496L865.746 36.5664L866.516 36.5664L866.516 267.427L842.697 295.766L784.274 295.766L784.145 295.594L239.455 295.594L239.648 295.766L233.292 300L842.505 300L868.442 269.875C868.828 269.472 869.02 268.32 869.02 268.32L869.02 35.5008L848.283 12.4896L229.504 12.0576L227 14.3616L845.651 13.9872Z"
                        fill="#56FEFE">
                    </path>
                    <path d="M171.409 16.5402L174.637 11.6267L170.622 11.6267L167.395 16.5402L171.409 16.5402Z"
                        fill="url(#linear_fill_96DADDB6-F729-4C03-8794-6F238E314F33)">
                    </path>
                    <g mask="url(#mask-6673A754-0FF8-4CC4-91A1-CBD8AB203101)">
                        <path d="M171.409 16.5402L174.637 11.6267L170.622 11.6267L167.395 16.5402L171.409 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M165.983 16.5402L169.21 11.6267L165.196 11.6267L161.968 16.5402L165.983 16.5402Z"
                        fill="url(#linear_fill_4878C3F3-8529-4E13-AE9E-690389748C4F)">
                    </path>
                    <g mask="url(#mask-938208EF-4B2D-4EB8-ADE0-7E2DBD4481CD)">
                        <path d="M165.983 16.5402L169.21 11.6267L165.196 11.6267L161.968 16.5402L165.983 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M160.556 16.5402L163.784 11.6267L159.749 11.6267L156.542 16.5402L160.556 16.5402Z"
                        fill="url(#linear_fill_E981FBB1-D382-4029-9A6D-17F244EFF059)">
                    </path>
                    <g mask="url(#mask-AC9FA9EF-6123-4672-ACA8-4CBBA7B8AD19)">
                        <path d="M160.556 16.5402L163.784 11.6267L159.749 11.6267L156.542 16.5402L160.556 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M187.991 16.5402L191.219 11.6267L187.184 11.6267L183.957 16.5402L187.991 16.5402Z"
                        fill="url(#linear_fill_2F51AE57-2DCF-4E09-AA5B-B891200399A9)">
                    </path>
                    <g mask="url(#mask-213C91FC-52C4-4AD8-A44A-76BD03A499CD)">
                        <path d="M187.991 16.5402L191.219 11.6267L187.184 11.6267L183.957 16.5402L187.991 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M210.524 16.5402L213.732 11.6267L209.718 11.6267L206.49 16.5402L210.524 16.5402Z"
                        fill="url(#linear_fill_143ED65E-FA2B-4444-9FCE-F513B7B25257)">
                    </path>
                    <g mask="url(#mask-F36CF457-12C6-46D4-8A54-1767857C31C9)">
                        <path d="M210.524 16.5402L213.732 11.6267L209.718 11.6267L206.49 16.5402L210.524 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M216.657 16.5402L219.885 11.6267L215.87 11.6267L212.643 16.5402L216.657 16.5402Z"
                        fill="url(#linear_fill_84D6C593-02F8-467D-9CC8-7A3DE9D41536)">
                    </path>
                    <g mask="url(#mask-D1597F95-E0E4-44B5-8138-4ABE455029A2)">
                        <path d="M216.657 16.5402L219.885 11.6267L215.87 11.6267L212.643 16.5402L216.657 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M222.81 16.5402L226.037 11.6267L222.002 11.6267L218.775 16.5402L222.81 16.5402Z"
                        fill="url(#linear_fill_56F20C8B-F1E6-4FD3-A709-375503D9148E)">
                    </path>
                    <g mask="url(#mask-D1A43CC8-7C29-40B5-B76D-92977803A8C4)">
                        <path d="M222.81 16.5402L226.037 11.6267L222.002 11.6267L218.775 16.5402L222.81 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M182.565 16.5402L185.793 11.6267L181.758 11.6267L178.53 16.5402L182.565 16.5402Z"
                        fill="url(#linear_fill_1D1EAA15-E59D-4AAA-9376-072BB74F041C)">
                    </path>
                    <g mask="url(#mask-A9927328-2C26-475F-B3F7-71BE27D16DA7)">
                        <path d="M182.565 16.5402L185.793 11.6267L181.758 11.6267L178.53 16.5402L182.565 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M177.138 16.5402L180.346 11.6267L176.331 11.6267L173.104 16.5402L177.138 16.5402Z"
                        fill="url(#linear_fill_8D474B0F-66E9-47D4-A800-BFFD652123A9)">
                    </path>
                    <g mask="url(#mask-7D112B6B-6752-4767-8A85-70881B1C6CD0)">
                        <path d="M177.138 16.5402L180.346 11.6267L176.331 11.6267L173.104 16.5402L177.138 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M204.634 16.5402L207.862 11.6267L203.847 11.6267L200.62 16.5402L204.634 16.5402Z"
                        fill="url(#linear_fill_81D2AB43-80F6-4A91-B684-37BF4008802F)">
                    </path>
                    <g mask="url(#mask-AD5EC6D5-352A-46A2-A27C-ED34CB21BE61)">
                        <path d="M204.634 16.5402L207.862 11.6267L203.847 11.6267L200.62 16.5402L204.634 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M199.207 16.5402L202.435 11.6267L198.421 11.6267L195.193 16.5402L199.207 16.5402Z"
                        fill="url(#linear_fill_28B3AC22-CD9E-40D0-B007-1DCB24708C17)">
                    </path>
                    <g mask="url(#mask-1C66415B-FEE6-4FBA-9AA3-DDBB00B2F5F1)">
                        <path d="M199.207 16.5402L202.435 11.6267L198.421 11.6267L195.193 16.5402L199.207 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M193.781 16.5402L197.009 11.6267L192.974 11.6267L189.767 16.5402L193.781 16.5402Z"
                        fill="url(#linear_fill_FD52FCA5-B77E-474D-8719-EB4531882505)">
                    </path>
                    <g mask="url(#mask-A98CFB82-6FAC-47C0-9DF4-58A9F33B0918)">
                        <path d="M193.781 16.5402L197.009 11.6267L192.974 11.6267L189.767 16.5402L193.781 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M155.13 16.5402L158.357 11.6267L154.323 11.6267L151.115 16.5402L155.13 16.5402Z"
                        fill="url(#linear_fill_07087109-A416-4B71-B8A3-83C7A3C4BB93)">
                    </path>
                    <g mask="url(#mask-D456E77E-163E-4D56-AF6B-5C0A5DE556BB)">
                        <path d="M155.13 16.5402L158.357 11.6267L154.323 11.6267L151.115 16.5402L155.13 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M149.703 16.5402L152.931 11.6267L148.896 11.6267L145.668 16.5402L149.703 16.5402Z"
                        fill="url(#linear_fill_217E012C-3092-4A6C-9E2A-63F7C0DA6871)">
                    </path>
                    <g mask="url(#mask-0E5DA530-51DA-4490-916F-36F47650D5F7)">
                        <path d="M149.703 16.5402L152.931 11.6267L148.896 11.6267L145.668 16.5402L149.703 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M144.277 16.5402L147.504 11.6267L143.469 11.6267L140.242 16.5402L144.277 16.5402Z"
                        fill="url(#linear_fill_1EF7DA6D-2F98-4D6A-B6BB-94A5BAE1FAD0)">
                    </path>
                    <g mask="url(#mask-5F5F8322-F257-4268-A101-AD7115FB3E53)">
                        <path d="M144.277 16.5402L147.504 11.6267L143.469 11.6267L140.242 16.5402L144.277 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <g mask="url(#mask-5F5F8322-F257-4268-A101-AD7115FB3E53)">
                        <path d="M138.85 16.5402L142.058 11.6267L138.043 11.6267L134.815 16.5402L138.85 16.5402Z"
                            fill="url(#linear_fill_E1DCE238-CB50-434A-8325-D1BAF794A029)">
                        </path>
                    </g>
                    <g mask="url(#mask-5F5F8322-F257-4268-A101-AD7115FB3E53)">
                        <path d="M138.85 16.5402L142.058 11.6267L138.043 11.6267L134.815 16.5402L138.85 16.5402Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path
                        d="M221.458 287.545C221.458 286.293 220.429 285.3 219.178 285.3C217.907 285.3 216.899 286.293 216.899 287.545C216.899 288.796 217.907 289.789 219.178 289.789C220.429 289.789 221.458 288.776 221.458 287.545Z"
                        fill="#56FEFE">
                    </path>
                    <path
                        d="M834.559 273.686C834.559 272.455 833.531 271.442 832.28 271.442C831.009 271.442 830 272.455 830 273.686C829.98 274.938 831.009 275.931 832.28 275.931C833.531 275.931 834.559 274.938 834.559 273.686Z"
                        fill="#56FEFE">
                    </path>
                    <path
                        d="M220.651 287.704L819.824 286.242L831.079 275.177C831.079 275.177 831.997 274.77 831.997 274.283L832.364 273.947L832.364 272.973L831.752 273.58C831.569 273.414 831.079 273.31 831.079 273.31C831.079 273.31 830.101 273.727 830.101 274.244C830.101 274.498 830.223 274.726 830.406 274.894L819.518 285.467L220.651 286.929L220.651 287.704Z"
                        fill="#56FEFE">
                    </path>
                    <path
                        d="M205.38 300.895L127.594 300.895L127.594 300.139L205.118 300.139L217.948 287.646L217.948 288.62L205.38 300.895Z"
                        fill="#56FEFE">
                    </path>
                    <path
                        d="M128.401 300.756C128.401 299.524 127.372 298.511 126.121 298.511C124.85 298.511 123.842 299.524 123.842 300.756C123.842 301.987 124.85 303 126.121 303C127.372 303 128.401 301.987 128.401 300.756Z"
                        fill="#56FEFE">
                    </path>
                    <path
                        d="M127.07 300.756C127.07 300.239 126.646 299.822 126.121 299.822C125.597 299.822 125.173 300.239 125.173 300.756C125.173 301.272 125.597 301.689 126.121 301.689C126.646 301.689 127.07 301.272 127.07 300.756Z"
                        fill="#56FEFE">
                    </path>
                    <path
                        d="M127.34 287.229L127.34 283.176L140.594 283.176L143.034 287.229L127.34 287.229ZM141.945 286.566L127.905 286.566L127.905 283.864L140.311 283.864L141.945 286.566Z"
                        fill-rule="evenodd" fill="#56FEFE">
                    </path>
                    <path d="M126.311 283.176L126.311 287.229L110.899 287.229L110.899 283.176L126.311 283.176Z"
                        fill="#56FEFE">
                    </path>
                    <path
                        d="M94.418 287.229L94.418 283.176L109.83 283.176L109.83 287.229L94.418 287.229ZM109.286 286.566L94.982 286.566L94.982 283.864L109.286 283.864L109.286 286.566Z"
                        fill-rule="evenodd" fill="#56FEFE">
                    </path>
                    <path d="M93.3486 283.176L93.3486 287.229L77.9365 287.229L77.9365 283.176L93.3486 283.176Z"
                        fill="#56FEFE">
                    </path>
                    <path d="M76.8877 283.176L76.8877 287.229L61.4756 287.229L61.4756 283.176L76.8877 283.176Z"
                        fill="#56FEFE">
                    </path>
                    <path
                        d="M38.8213 287.229L38.8213 283.176L60.4063 283.176L60.4063 287.229L38.8213 287.229ZM59.8408 286.566L39.3652 286.566L39.3652 283.864L59.8408 283.864L59.8408 286.566Z"
                        fill-rule="evenodd" fill="#56FEFE">
                    </path>
                    <path
                        d="M117.984 300.965L23.2484 300.965L3.2718 278.19L3.2718 277.836L1.8753 41.3645L26.1478 10.8615L84.2555 10.8615L126.855 11.068L133 8L26.4005 8L0.5453 38.857C0.1995 39.27 0 40.45 0 40.45L0 278.928L20.6549 302.469L120.804 303L117.984 300.965Z"
                        fill="#56FEFE">
                    </path>
                    <path
                        d="M256.718 7.03687L360.443 7.03687L360.443 7.9709L256.974 7.9709L244.146 23.4234L244.146 22.219L256.718 7.03687Z"
                        fill="#56FEFE">
                    </path>
                    <path
                        d="M359.637 7.20875C359.637 8.75673 360.666 9.98489 361.916 9.98489C363.167 9.98489 364.196 8.73174 364.196 7.20875C364.196 5.68576 363.187 4.43262 361.916 4.43262C360.645 4.43262 359.637 5.68576 359.637 7.20875Z"
                        fill="#56FEFE">
                    </path>
                    <path
                        d="M243.158 21.8755C243.158 23.4235 244.187 24.6516 245.438 24.6516C246.709 24.6516 247.717 23.3985 247.717 21.8755C247.738 20.3525 246.709 19.0994 245.438 19.0994C244.167 19.0994 243.158 20.3525 243.158 21.8755Z"
                        fill="#56FEFE">
                    </path>
                    <path
                        d="M244.49 21.8756C244.49 22.5144 244.913 23.0303 245.438 23.0303C245.962 23.0303 246.386 22.5144 246.386 21.8756C246.386 21.2369 245.962 20.7209 245.438 20.7209C244.913 20.7209 244.49 21.2369 244.49 21.8756Z"
                        fill="#56FEFE">
                    </path>
                    <g opacity="0.05">
                        <path d="M317 0L314.647 0L308 8L310.353 8L317 0Z" fill="#56FEFE">
                        </path>
                    </g>
                    <g opacity="0.1">
                        <path d="M322 0L319.771 0L312 10L314.229 10L322 0Z" fill="#56FEFE">
                        </path>
                    </g>
                    <g opacity="0.2">
                        <path d="M327 0L324.768 0L317 10L319.232 10L327 0Z" fill="#56FEFE">
                        </path>
                    </g>
                    <g opacity="0.4">
                        <path d="M332 0L329.771 0L322 10L324.229 10L332 0Z" fill="#56FEFE">
                        </path>
                    </g>
                    <g opacity="0.6">
                        <path d="M336 0L334.005 0.015L327 10L329.009 10L336 0Z" fill="#56FEFE">
                        </path>
                    </g>
                    <g opacity="0.8">
                        <path d="M341 0L338.768 0L331 10L333.232 9.985L341 0Z" fill="#56FEFE">
                        </path>
                    </g>
                    <path d="M346 0L343.771 0.015L336 10L338.229 10L346 0Z" fill="#56FEFE">
                    </path>
                    <path
                        d="M18.6087 281.34C12.7442 281.34 8 276.591 8 270.755C8 264.903 12.7591 260.169 18.6087 260.169C24.4732 260.154 29.2174 264.903 29.2174 270.755C29.2174 276.606 24.4583 281.34 18.6087 281.34Z"
                        stroke="rgba(86, 254, 254, 1)" stroke-width="1">
                    </path>
                    <path
                        d="M18.4922 278.203C14.4473 278.203 11.1724 274.936 11.1724 270.9C11.1724 266.864 14.4473 263.596 18.4922 263.596C22.5372 263.596 25.8121 266.864 25.8121 270.9C25.8121 274.936 22.5372 278.203 18.4922 278.203Z"
                        stroke="rgba(86, 254, 254, 1)" stroke-width="0.5">
                    </path>
                    <g opacity="0.4">
                        <path stroke="rgba(86, 254, 254, 1)" stroke-width="2" d="M18.8301 264L17.8301 260">
                        </path>
                    </g>
                    <g opacity="0.4">
                        <path stroke="rgba(86, 254, 254, 1)" stroke-width="2" d="M22.8301 265L24.8301 262">
                        </path>
                    </g>
                    <g opacity="0.2">
                        <path
                            d="M22.6658 274.602C21.6731 274.602 20.8623 273.791 20.8623 272.799C20.8623 271.806 21.6656 270.995 22.6658 270.995C23.6584 271.003 24.4692 271.806 24.4692 272.799C24.4692 273.791 23.666 274.602 22.6658 274.602Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <g opacity="0.6">
                        <path
                            d="M17.1119 272.857C15.2056 272.857 13.6484 271.304 13.6484 269.401C13.6484 267.499 15.1911 265.946 17.1119 265.946C19.0182 265.946 20.5754 267.499 20.5754 269.401C20.5754 271.304 19.0328 272.857 17.1119 272.857Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <path
                        d="M18.4779 251.036L23.4255 258.049L21.112 258.049L18.4486 254.085L15.5378 258.049L12.9478 258.049L18.4779 251.036Z"
                        fill="#56FEFE">
                    </path>
                    <g opacity="0.8">
                        <path
                            d="M18.4779 245.78L23.4255 252.793L21.112 252.793L18.4486 248.844L15.5378 252.793L12.9478 252.793L18.4779 245.78Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <g opacity="0.7">
                        <path
                            d="M18.4779 240.291L23.4255 247.304L21.112 247.304L18.4486 243.34L15.5378 247.304L12.9478 247.304L18.4779 240.291Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <g opacity="0.6">
                        <path
                            d="M18.4779 235.034L23.4255 242.048L21.112 242.048L18.4486 238.099L15.5378 242.048L12.9478 242.048L18.4779 235.034Z"
                            fill="#56FEFE">
                        </path>
                    </g>
                    <g opacity="0.5">
                        <path
                            d="M18.4779 228.994L23.4255 235.993L21.112 235.993L18.4486 232.043L15.5378 235.993L12.9478 235.993L18.4779 228.994Z"
                            stroke="rgba(86, 254, 254, 1)" stroke-width="1">
                        </path>
                    </g>
                    <g opacity="0.4">
                        <path
                            d="M18.4779 222.953L23.4255 229.952L21.112 229.952L18.4486 226.003L15.5378 229.952L12.9478 229.952L18.4779 222.953Z"
                            stroke="rgba(86, 254, 254, 1)" stroke-width="1">
                        </path>
                    </g>
                    <g opacity="0.2">
                        <path
                            d="M18.4779 217L23.4255 223.999L21.112 223.999L18.4486 220.049L15.5378 223.999L12.9478 223.999L18.4779 217Z"
                            stroke="rgba(86, 254, 254, 1)" stroke-width="1">
                        </path>
                    </g>
                    <g opacity="0.6">
                        <path
                            d="M842.756 19.5003L28.1469 19.7989L8.50196 43.8822L9.26948 252.023L6.2695 252.034L5.5 43.3559L6.99999 43.3504L5.83765 42.4023L26.2722 17.3511L26.7221 16.7995L27.434 16.7992L843.447 16.5L843.447 18L844.588 17.0261L862.629 38.1605L861.488 39.1344L862.988 39.1344L862.988 266.83L862.634 267.249L842.713 290.858L842.263 291.391L841.566 291.391L242.809 291.5L242.809 288.5L840.869 288.391L859.988 265.733L859.988 39.6875L842.756 19.5003Z"
                            fill-rule="evenodd" fill="#56FEFE">
                        </path>
                    </g>
                    <path stroke="rgba(86, 254, 254, 1)" stroke-width="1" d="M841.256 39L854.631 39">
                    </path>
                    <path stroke="rgba(86, 254, 254, 1)" stroke-width="1" d="M837.988 34.9956L851.726 34.9956">
                    </path>
                    <path stroke="rgba(86, 254, 254, 1)" stroke-width="1" d="M835.406 31.8755L848.781 31.8755">
                    </path>
                    <path stroke="rgba(86, 254, 254, 1)" stroke-width="1" d="M832.562 28.4116L846.3 28.4116">
                    </path>
                    <path stroke="rgba(86, 254, 254, 1)" stroke-width="1" d="M830 25.2668L843.354 25.2668">
                    </path>
                    <defs>
                        <linearGradient id="linear_fill_96DADDB6-F729-4C03-8794-6F238E314F33" x1="209.22430419921875"
                            y1="14.0869140625" x2="198.96759033203125" y2="14.0869140625"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-6673A754-0FF8-4CC4-91A1-CBD8AB203101" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M171.409 16.5402L174.637 11.6267L170.622 11.6267L167.395 16.5402L171.409 16.5402Z"
                                fill="url(#linear_fill_96DADDB6-F729-4C03-8794-6F238E314F33)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_4878C3F3-8529-4E13-AE9E-690389748C4F" x1="209.23977661132812"
                            y1="14.0869140625" x2="188.1229248046875" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-938208EF-4B2D-4EB8-ADE0-7E2DBD4481CD" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M165.983 16.5402L169.21 11.6267L165.196 11.6267L161.968 16.5402L165.983 16.5402Z"
                                fill="url(#linear_fill_4878C3F3-8529-4E13-AE9E-690389748C4F)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_E981FBB1-D382-4029-9A6D-17F244EFF059" x1="209.25396728515625"
                            y1="14.0869140625" x2="177.2742462158203" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-AC9FA9EF-6123-4672-ACA8-4CBBA7B8AD19" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M160.556 16.5402L163.784 11.6267L159.749 11.6267L156.542 16.5402L160.556 16.5402Z"
                                fill="url(#linear_fill_E981FBB1-D382-4029-9A6D-17F244EFF059)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_2F51AE57-2DCF-4E09-AA5B-B891200399A9" x1="225.79653930664062"
                            y1="14.0869140625" x2="215.51968383789062" y2="14.0869140625"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-213C91FC-52C4-4AD8-A44A-76BD03A499CD" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M187.991 16.5402L191.219 11.6267L187.184 11.6267L183.957 16.5402L187.991 16.5402Z"
                                fill="url(#linear_fill_2F51AE57-2DCF-4E09-AA5B-B891200399A9)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_143ED65E-FA2B-4444-9FCE-F513B7B25257" x1="248.33123779296875"
                            y1="14.0869140625" x2="238.06463623046875" y2="14.0869140625"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-F36CF457-12C6-46D4-8A54-1767857C31C9" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M210.524 16.5402L213.732 11.6267L209.718 11.6267L206.49 16.5402L210.524 16.5402Z"
                                fill="url(#linear_fill_143ED65E-FA2B-4444-9FCE-F513B7B25257)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_84D6C593-02F8-467D-9CC8-7A3DE9D41536" x1="254.46975708007812"
                            y1="14.0869140625" x2="244.22088623046875" y2="14.0869140625"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-D1597F95-E0E4-44B5-8138-4ABE455029A2" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M216.657 16.5402L219.885 11.6267L215.87 11.6267L212.643 16.5402L216.657 16.5402Z"
                                fill="url(#linear_fill_84D6C593-02F8-467D-9CC8-7A3DE9D41536)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_56F20C8B-F1E6-4FD3-A709-375503D9148E" x1="260.6119689941406"
                            y1="14.0869140625" x2="250.3406982421875" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-D1A43CC8-7C29-40B5-B76D-92977803A8C4" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M222.81 16.5402L226.037 11.6267L222.002 11.6267L218.775 16.5402L222.81 16.5402Z"
                                fill="url(#linear_fill_56F20C8B-F1E6-4FD3-A709-375503D9148E)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_1D1EAA15-E59D-4AAA-9376-072BB74F041C" x1="225.81057739257812"
                            y1="14.0869140625" x2="204.67425537109375" y2="14.0869140625"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-A9927328-2C26-475F-B3F7-71BE27D16DA7" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M182.565 16.5402L185.793 11.6267L181.758 11.6267L178.53 16.5402L182.565 16.5402Z"
                                fill="url(#linear_fill_1D1EAA15-E59D-4AAA-9376-072BB74F041C)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_8D474B0F-66E9-47D4-A800-BFFD652123A9" x1="225.8272705078125"
                            y1="14.0869140625" x2="193.8268585205078" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-7D112B6B-6752-4767-8A85-70881B1C6CD0" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M177.138 16.5402L180.346 11.6267L176.331 11.6267L173.104 16.5402L177.138 16.5402Z"
                                fill="url(#linear_fill_8D474B0F-66E9-47D4-A800-BFFD652123A9)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_81D2AB43-80F6-4A91-B684-37BF4008802F" x1="242.44781494140625"
                            y1="14.0869140625" x2="232.19235229492188" y2="14.0869140625"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-AD5EC6D5-352A-46A2-A27C-ED34CB21BE61" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M204.634 16.5402L207.862 11.6267L203.847 11.6267L200.62 16.5402L204.634 16.5402Z"
                                fill="url(#linear_fill_81D2AB43-80F6-4A91-B684-37BF4008802F)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_28B3AC22-CD9E-40D0-B007-1DCB24708C17" x1="242.46182250976562"
                            y1="14.0869140625" x2="221.34683227539062" y2="14.0869140625"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-1C66415B-FEE6-4FBA-9AA3-DDBB00B2F5F1" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M199.207 16.5402L202.435 11.6267L198.421 11.6267L195.193 16.5402L199.207 16.5402Z"
                                fill="url(#linear_fill_28B3AC22-CD9E-40D0-B007-1DCB24708C17)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_FD52FCA5-B77E-474D-8719-EB4531882505" x1="242.48089599609375"
                            y1="14.0869140625" x2="210.501220703125" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-A98CFB82-6FAC-47C0-9DF4-58A9F33B0918" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M193.781 16.5402L197.009 11.6267L192.974 11.6267L189.767 16.5402L193.781 16.5402Z"
                                fill="url(#linear_fill_FD52FCA5-B77E-474D-8719-EB4531882505)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_07087109-A416-4B71-B8A3-83C7A3C4BB93" x1="209.2591552734375"
                            y1="14.0869140625" x2="166.41989135742188" y2="14.0869140625"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-D456E77E-163E-4D56-AF6B-5C0A5DE556BB" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M155.13 16.5402L158.357 11.6267L154.323 11.6267L151.115 16.5402L155.13 16.5402Z"
                                fill="url(#linear_fill_07087109-A416-4B71-B8A3-83C7A3C4BB93)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_217E012C-3092-4A6C-9E2A-63F7C0DA6871" x1="209.2247314453125"
                            y1="14.0869140625" x2="155.51377868652344" y2="14.0869140625"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-0E5DA530-51DA-4490-916F-36F47650D5F7" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M149.703 16.5402L152.931 11.6267L148.896 11.6267L145.668 16.5402L149.703 16.5402Z"
                                fill="url(#linear_fill_217E012C-3092-4A6C-9E2A-63F7C0DA6871)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_1EF7DA6D-2F98-4D6A-B6BB-94A5BAE1FAD0" x1="209.22445678710938"
                            y1="14.0869140625" x2="144.6598663330078" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                        <mask id="mask-5F5F8322-F257-4268-A101-AD7115FB3E53" style="mask-type:alpha"
                            maskUnits="userSpaceOnUse">
                            <path d="M144.277 16.5402L147.504 11.6267L143.469 11.6267L140.242 16.5402L144.277 16.5402Z"
                                fill="url(#linear_fill_1EF7DA6D-2F98-4D6A-B6BB-94A5BAE1FAD0)">
                            </path>
                        </mask>
                        <linearGradient id="linear_fill_E1DCE238-CB50-434A-8325-D1BAF794A029" x1="209.26678466796875"
                            y1="14.0869140625" x2="135.8214111328125" y2="14.0869140625" gradientUnits="userSpaceOnUse">
                            <stop offset="0.002645500004291534" stop-color="#FFFFFF" />
                            <stop offset="1" stop-color="#000000" />
                        </linearGradient>
                    </defs>
                </svg>

                <!-- 标题区域 -->
                <div class="titlePanel">
                    <p>{{ activeDialogWebsiteName }}</p>
                    <!-- 标题装饰 -->
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="809.7092895507812" height="3.5" viewBox="0 0 809.7092895507812 3.5" fill="none"
                        preserveAspectRatio="none">
                        <path
                            d="M762.257 0L763.113 0.854002L764.764 2.5L0 2.5L0 3.5L809.709 3.5L808.853 2.646L806.347 0.145998L806.2 0L762.257 0ZM766.18 2.5L764.676 1L805.787 1L807.291 2.5L766.18 2.5Z"
                            fill-rule="evenodd" fill="url(#linear_fill_79CA141F-7572-4DD6-AEA5-15AE798F30A4)">
                        </path>
                        <defs>
                            <linearGradient id="linear_fill_79CA141F-7572-4DD6-AEA5-15AE798F30A4" x1="306.9585266113281"
                                y1="4.1978759765625" x2="14.521636962890625" y2="4.19775390625"
                                gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#56FEFE" />
                                <stop offset="1" stop-color="#56FEFE" stop-opacity="0.3" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>

                <!-- 跳转平台名称 -->
                <!-- <div class="chartPanelWebsiteName">
                    <span>{{ activeDialogWebsiteName }}</span>
                </div> -->
                <!-- 跳转为第三方平台时 -->
                <div v-show="isWebsite" style="flex:1;margin:0px 0.5rem 3rem 2.5rem;">
                    <div class="chartPanelTop">
                        <div ref="dialogChartPie1Ref"></div>
                        <div ref="dialogChartPie2Ref"></div>
                        <div ref="dialogChartPie3Ref"></div>
                    </div>
                    <div class="chartPanelBottom">
                        <div ref="dialogChartBarRef"></div>
                        <div style="flex:2;" ref="dialogChartLineRef"></div>
                    </div>
                </div>

                <!-- 本地数据统计展示 -->
                <div v-show="!isWebsite"
                    style="flex:1;margin:0px 0.5rem 3rem 2.5rem;flex-direction: row-reverse;display: flex;">
                    <div v-show="activeDialogWebsiteName === '产值情况统计'" style="flex:1;" ref="replenishmentChartRef">
                    </div>
                    <div style="flex:1;" ref="currentChartRef"></div>
                </div>

                <!-- 跳转按钮 -->
                <div class="chartPanelButton" v-show="isWebsite">
                    <span @click="pushToOtherWebSiteHandler(activeDialogWebsiteName, true)">直接访问</span>
                </div>
                <!-- 关闭按钮 -->
                <!-- <div class="dialogWindowClose" @click="showDialog(false)">
                    <img src="../assets/close.svg" alt="">
                </div> -->
            </div>
        </div>

        <!-- 背景雨效果 -->
        <canvas class="bkRainCanvas" ref="bkRainCanvasRef"></canvas>


        <!-- 多级选择弹窗 -->
        <div class="btnDialogWindow" ref="btnDialogWindowRef" @click="showBtnDialogHandler($event, false)">
            <div class="btnDialogBody">
                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" width="296.5" height="129.20794677734375"
                    viewBox="0 0 296.5 129.20794677734375" fill="none">
                    <g filter="url(#filter_63D76A0E-BF88-49B9-9C9E-1F802C986316)">
                        <path
                            d="M296 67.9985L286.514 58.4997L286.514 25.5028L286.514 0.5L244.997 0.5L237.491 7.997L97.5126 7.997L90.007 0.5L14.5067 0.5L14.5067 11.5033L0.5 25.5028L0.5 128L11.4926 116.997L286.514 116.997L296 107.498L296 67.9985Z"
                            stroke="rgba(10, 214, 251, 1)" stroke-width="1" fill="#03111C" fill-opacity="0.6">
                        </path>
                    </g>
                    <path d="M296 68.0004L296 107L286.5 116.5L286.5 58.5L296 68.0004Z" fill="#56FEFE"
                        fill-opacity="0.3">
                    </path>
                    <path
                        d="M25.9953 8.00075L25.9953 11.5011L0.5 37L0.5 25.4988L14.5021 11.5011L14.5021 0.5L90.0038 0.5L97 8.00075L25.9953 8.00075Z"
                        fill="#56FEFE" fill-opacity="0.3">
                    </path>
                    <rect x="3.5" y="25.80328369140625" width="4.67154859675258" height="4.67154859675258"
                        transform="rotate(-45 3.5 25.80328369140625)" fill="#0AD6FB">
                    </rect>
                    <rect x="8.5" y="20.80328369140625" width="4.67154859675258" height="4.67154859675258"
                        transform="rotate(-45 8.5 20.80328369140625)" fill="#0AD6FB">
                    </rect>
                    <rect x="12.5" y="16.80328369140625" width="4.67154859675258" height="4.67154859675258"
                        transform="rotate(-45 12.5 16.80328369140625)" fill="#0AD6FB">
                    </rect>
                    <defs>
                        <filter id="filter_63D76A0E-BF88-49B9-9C9E-1F802C986316" x="0" y="0" width="296.5"
                            height="129.20794677734375" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="feFloodId_63D76A0E-BF88-49B9-9C9E-1F802C986316" />
                            <feGaussianBlur in="feFloodId_63D76A0E-BF88-49B9-9C9E-1F802C986316" stdDeviation_bg="5"
                                type="BackgroundImage" />
                            <feComposite in2="SourceAlpha" operator="in"
                                result="background_Blur_63D76A0E-BF88-49B9-9C9E-1F802C986316" />
                            <feBlend mode="normal" in="SourceGraphic"
                                in2="background_Blur_63D76A0E-BF88-49B9-9C9E-1F802C986316"
                                result="shape_63D76A0E-BF88-49B9-9C9E-1F802C986316" />
                        </filter>
                    </defs>
                </svg>
                <!-- 按钮组 -->
                <div class="btnGroupPanel">
                    <div @click="pushToOtherWebSiteHandler('资源管理')">
                        <img src="../assets/ziYuanGuanLi.svg" alt="">
                        <span>油机监管</span>
                        <div class="borderPanel"></div>
                    </div>
                    <div @click="pushToOtherWebSiteHandler('资源管理驾驶舱')">
                        <img src="../assets/ziYuanGuanLi.svg" alt="">
                        <span>资源驾驶舱</span>
                        <div class="borderPanel"></div>
                    </div>
                    <div @click="pushToOtherWebSiteHandler('收发料管理')">
                        <img src="../assets/ziYuanGuanLi.svg" alt="">
                        <span>收发料管理</span>
                        <div class="borderPanel"></div>
                    </div>
                    <div @click="pushToOtherWebSiteHandler('混凝土数据库')">
                        <img src="../assets/ziYuanGuanLi.svg" alt="">
                        <span>混凝土数据库</span>
                        <div class="borderPanel"></div>
                    </div>
                </div>

                <!-- 关闭按钮 -->
                <!-- <div class="btnDialogCloseBtn" title="关闭" @click="showBtnDialogHandler($event, false)">
                    <img src="../assets/close.svg" alt="">
                </div> -->
            </div>
        </div>

        <!-- 多级选择弹窗2 -->
        <div class="btnDialogWindow" ref="btnDialog2WindowRef" @click="showBtnDialog2Handler($event, false)">
            <div class="btnDialogBody">
                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" width="296.5" height="129.20794677734375"
                    viewBox="0 0 296.5 129.20794677734375" fill="none">
                    <g filter="url(#filter_63D76A0E-BF88-49B9-9C9E-1F802C986316)">
                        <path
                            d="M296 67.9985L286.514 58.4997L286.514 25.5028L286.514 0.5L244.997 0.5L237.491 7.997L97.5126 7.997L90.007 0.5L14.5067 0.5L14.5067 11.5033L0.5 25.5028L0.5 128L11.4926 116.997L286.514 116.997L296 107.498L296 67.9985Z"
                            stroke="rgba(10, 214, 251, 1)" stroke-width="1" fill="#03111C" fill-opacity="0.6">
                        </path>
                    </g>
                    <path d="M296 68.0004L296 107L286.5 116.5L286.5 58.5L296 68.0004Z" fill="#56FEFE"
                        fill-opacity="0.3">
                    </path>
                    <path
                        d="M25.9953 8.00075L25.9953 11.5011L0.5 37L0.5 25.4988L14.5021 11.5011L14.5021 0.5L90.0038 0.5L97 8.00075L25.9953 8.00075Z"
                        fill="#56FEFE" fill-opacity="0.3">
                    </path>
                    <rect x="3.5" y="25.80328369140625" width="4.67154859675258" height="4.67154859675258"
                        transform="rotate(-45 3.5 25.80328369140625)" fill="#0AD6FB">
                    </rect>
                    <rect x="8.5" y="20.80328369140625" width="4.67154859675258" height="4.67154859675258"
                        transform="rotate(-45 8.5 20.80328369140625)" fill="#0AD6FB">
                    </rect>
                    <rect x="12.5" y="16.80328369140625" width="4.67154859675258" height="4.67154859675258"
                        transform="rotate(-45 12.5 16.80328369140625)" fill="#0AD6FB">
                    </rect>
                    <defs>
                        <filter id="filter_63D76A0E-BF88-49B9-9C9E-1F802C986316" x="0" y="0" width="296.5"
                            height="129.20794677734375" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="feFloodId_63D76A0E-BF88-49B9-9C9E-1F802C986316" />
                            <feGaussianBlur in="feFloodId_63D76A0E-BF88-49B9-9C9E-1F802C986316" stdDeviation_bg="5"
                                type="BackgroundImage" />
                            <feComposite in2="SourceAlpha" operator="in"
                                result="background_Blur_63D76A0E-BF88-49B9-9C9E-1F802C986316" />
                            <feBlend mode="normal" in="SourceGraphic"
                                in2="background_Blur_63D76A0E-BF88-49B9-9C9E-1F802C986316"
                                result="shape_63D76A0E-BF88-49B9-9C9E-1F802C986316" />
                        </filter>
                    </defs>
                </svg>
                <!-- 按钮组 -->
                <div class="btnGroupPanel">
                    <div @click="pushToOtherWebSiteHandler('质量管理')">
                        <img src="../assets/zhiLiangGuanLi.svg" alt="">
                        <span>质量管理</span>
                        <div class="borderPanel"></div>
                    </div>
                    <div @click="pushToOtherWebSiteHandler('工程内业')">
                        <img src="../assets/zhiLiangGuanLi.svg" alt="">
                        <span>工程内业</span>
                        <div class="borderPanel"></div>
                    </div>
                </div>

                <!-- 关闭按钮 -->
                <!-- <div class="btnDialogCloseBtn" title="关闭" @click="showBtnDialogHandler($event, false)">
                    <img src="../assets/close.svg" alt="">
                </div> -->
            </div>
        </div>

          <!-- 多级选择弹窗3 -->
        <div class="btnDialogWindow" ref="btnDialog3WindowRef" @click="showBtnDialog3Handler($event, false)">
            <div class="btnDialogBody">
                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" width="296.5" height="129.20794677734375"
                    viewBox="0 0 296.5 129.20794677734375" fill="none">
                    <g filter="url(#filter_63D76A0E-BF88-49B9-9C9E-1F802C986316)">
                        <path
                            d="M296 67.9985L286.514 58.4997L286.514 25.5028L286.514 0.5L244.997 0.5L237.491 7.997L97.5126 7.997L90.007 0.5L14.5067 0.5L14.5067 11.5033L0.5 25.5028L0.5 128L11.4926 116.997L286.514 116.997L296 107.498L296 67.9985Z"
                            stroke="rgba(10, 214, 251, 1)" stroke-width="1" fill="#03111C" fill-opacity="0.6">
                        </path>
                    </g>
                    <path d="M296 68.0004L296 107L286.5 116.5L286.5 58.5L296 68.0004Z" fill="#56FEFE"
                        fill-opacity="0.3">
                    </path>
                    <path
                        d="M25.9953 8.00075L25.9953 11.5011L0.5 37L0.5 25.4988L14.5021 11.5011L14.5021 0.5L90.0038 0.5L97 8.00075L25.9953 8.00075Z"
                        fill="#56FEFE" fill-opacity="0.3">
                    </path>
                    <rect x="3.5" y="25.80328369140625" width="4.67154859675258" height="4.67154859675258"
                        transform="rotate(-45 3.5 25.80328369140625)" fill="#0AD6FB">
                    </rect>
                    <rect x="8.5" y="20.80328369140625" width="4.67154859675258" height="4.67154859675258"
                        transform="rotate(-45 8.5 20.80328369140625)" fill="#0AD6FB">
                    </rect>
                    <rect x="12.5" y="16.80328369140625" width="4.67154859675258" height="4.67154859675258"
                        transform="rotate(-45 12.5 16.80328369140625)" fill="#0AD6FB">
                    </rect>
                    <defs>
                        <filter id="filter_63D76A0E-BF88-49B9-9C9E-1F802C986316" x="0" y="0" width="296.5"
                            height="129.20794677734375" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="feFloodId_63D76A0E-BF88-49B9-9C9E-1F802C986316" />
                            <feGaussianBlur in="feFloodId_63D76A0E-BF88-49B9-9C9E-1F802C986316" stdDeviation_bg="5"
                                type="BackgroundImage" />
                            <feComposite in2="SourceAlpha" operator="in"
                                result="background_Blur_63D76A0E-BF88-49B9-9C9E-1F802C986316" />
                            <feBlend mode="normal" in="SourceGraphic"
                                in2="background_Blur_63D76A0E-BF88-49B9-9C9E-1F802C986316"
                                result="shape_63D76A0E-BF88-49B9-9C9E-1F802C986316" />
                        </filter>
                    </defs>
                </svg>
                <!-- 按钮组 -->
                <div class="btnGroupPanel">
                    <div @click="pushToOtherWebSiteHandler('安全生产')">
                        <img src="../assets/anQuanGuanLi.svg" alt="">
                        <span>数据监管</span>
                        <div class="borderPanel"></div>
                    </div>
                    <div @click="pushToOtherWebSiteHandler('六项机制')">
                        <img src="../assets/anQuanGuanLi.svg" alt="">
                        <span>安全监管</span>
                        <div class="borderPanel"></div>
                    </div>
                </div>

                <!-- 关闭按钮 -->
                <!-- <div class="btnDialogCloseBtn" title="关闭" @click="showBtnDialogHandler($event, false)">
                    <img src="../assets/close.svg" alt="">
                </div> -->
            </div>
        </div>

        <!-- 项目详情组件 -->
        <dialog-window :opening.sync="dialogInfo.opening"></dialog-window>

        <!-- 8大目标弹窗 -->
        <dream-window :opening.sync="dreamDialogInfo.isOpening" :dreamId="dreamDialogInfo.dreamId"></dream-window>
    </div>
</template>

<script>
import UP_IMG from "@/assets/up.png";
import ORANGE_IMG from "@/assets/orange.png";
import BORDER2_IMG from "@/assets/border2.png";
import * as Echarts from 'echarts';
import 'echarts-liquidfill';
import axios from 'axios';
import Decimal from 'decimal.js';
import { MessageBox } from "element-ui";
import DialogWindow from "./DialogWindow";
import DreamWindow from "./DreamWindow";


/**
 * 综合管理驾驶舱
 */
export default {
    name: 'DashBoard',
    components: {
        DialogWindow,
        DreamWindow
    },
    data() {
        return {
            // dom根元素的字号
            domFontSize: null,
            upImage: UP_IMG,
            projectTypeList: [
                // { id: 1, label: "水利", value: "15%", percent: "" },
                // { id: 2, label: "市政", value: "33%", percent: "" },
                // { id: 3, label: "公路", value: "27%", percent: "" },
                // { id: 4, label: "建筑", value: "8%", percent: "" },
                // { id: 5, label: "机电", value: "10%", percent: "" },
                // { id: 6, label: "农业", value: "123456", percent: "" },
                // { id: 7, label: "其它", value: "123456", percent: "" },
            ],
            // top5颜色循环
            timerFlag: null,
            activeItemId: 1,
            // 用于跟踪视频是否已经完整播放
            hasPlayed: false,
            // 设置播放间隔 - 开始时间
            startTime: 3.18,
            // 设置播放间隔 - 结束时间 
            endTime: 8.067,
            totalAmountInfo: {
                IND_000001: null,
                IND_000002: null,
                IND_000003: null,
                IND_000004: null,
            },
            totalGoalInfo: {
                data1: this.getRangeRandom(5000000000, 5000000000),
                data2: this.getRangeRandom(5000000, 500000000),
                data3: this.getRangeRandom(10, 300)
            },
            awardInfo: {
                data1: this.getRangeRandom(10, 500, ""),
                data2: this.getRangeRandom(10, 500, ""),
                data3: this.getRangeRandom(10, 500, ""),
                data4: this.getRangeRandom(10, 500, ""),
                data5: this.getRangeRandom(10, 500, ""),
                data6: this.getRangeRandom(10, 500, ""),
            },
            // 弹窗中的图表
            dwChartPie1Instance: null,
            dwChartPie2Instance: null,
            dwChartPie3Instance: null,
            dwChartBarInstance: null,
            dwChartLineInstance: null,
            // 弹窗图标(当前页数据呈现)
            currentChartRefInstance: null,
            // 弹窗图表(当前页数据呈现-补充图表)
            replenishmentChartRefInstance: null,
            // 当前打开弹窗的平台名称
            activeDialogWebsiteName: null,
            // 区域项目建设情况统计图表
            awardInfoPanelInstance: null,
            // 平台跳转链接
            websiteHrefMap: new Map([
                // 修改  资源管理驾驶舱 -> 人力管理驾驶舱
                ["人力管理驾驶舱", "http://113.44.145.139:9999/view/index.jsp"],
                // 8大应用平台
                ["科创管理", 'http://www.hljsd.com//oauth2/authorize?response_type=code&client_id=1001&redirect_uri=http://113.44.152.248:8086/gotohome&scope=code'],
                // 原水利方舟
                ["人力管理", "http://www.hljsd.com//oauth2/authorize?response_type=code&client_id=1040&redirect_uri=http://slhr.hcgccloud.com/sso_hr.jsp&scope=code"],
                ["智慧采购", "http://www.ruicw.com/"],
                ["OA办公", "http://oa.hcgccloud.com/seeyon/index.jsp"],//"https://oa.hcgccloud.com/seeyon/index.jsp"],
                ["资源管理", "http://www.hljsd.com//oauth2/authorize?response_type=code&client_id=1020&redirect_uri=https://master.xgwjj.com/&scope=code"],//"http://master.xgwjj.com/"],
                ["质量管理", "http://www.hljsd.com//oauth2/authorize?response_type=code&client_id=1010&redirect_uri=http://113.44.145.139:81/login&scope=code"],// http://121.36.43.17:81/login/
                ["安全管理", "http://www.hljsd.com//oauth2/authorize?response_type=code&client_id=1030&redirect_uri=https://ljsd.bosafe.com/default/org.gocom.components.coframe.auth.login.HljsdLogin.flow&scope=code"],//"https://ljsd.bosafe.com/default/coframe/auth/login/login.jsp"],
                // ["ERP管理", "http://www.hljsd.com/oauth2/authorize?response_type=code&client_id=1080&redirect_uri=http://42.101.60.134:8777/service/genHWToken&scope=code"],
                ["ERP管理", "http://www.hljsd.com/oauth2/authorize?response_type=code&client_id=1080&redirect_uri=https://lsld-nc.hcgccloud.com/service/genHWToken&scope=code"],
                // 4大驾驶舱
                ["科创管理驾驶舱", 'http://www.hljsd.com//oauth2/authorize?response_type=code&client_id=1001&redirect_uri=http://113.44.152.248:8086/ossLogin&scope=code'],
                ["安全管理驾驶舱", "http://www.hljsd.com//oauth2/authorize?response_type=code&client_id=1030&redirect_uri=https://ljsd.bosafe.com/default/coframe/auth/navigationView/companyIndex1.jsp&scope=code"],
                ["资源管理驾驶舱", "http://121.36.58.3:58230/datascreen/procure.html"],
                ["经营管理驾驶舱", "http://121.36.58.3:58230/datascreen/value.html"],
                // 快捷导航
                ["数智水利", null],
                ["智慧工地", "http://111.42.226.70:13082/#/largescreen"],
                ["智慧农业", "http://8.130.79.30:29916/platform/home"],
                ["业务管理系统", "http://www.hljsd.com//oauth2/authorize?response_type=code&client_id=1050&redirect_uri=http://121.36.58.3:58230/oauth2/callback&scope=code"],
                // 集团要闻
                ["集团要闻", "https://www.ljsdgrp.com/#page2"],
                // 新增 数智工坊 2025年4月27日22:03:32
                ["数智工坊", "http://113.44.152.248:9999/sz/index.jsp"],
                ["党辉企航", "http://113.44.152.248:8877/"],//"http://8.154.24.146:8083"],
                // 收发料管理 -> 与资源管理合并在 机物料联 中
                ["收发料管理", "http://www.hljsd.com//oauth2/authorize?response_type=code&client_id=1070&redirect_uri=http://transport.screen.ljkjkf.com?Type=ShuiLi&scope=code "],
                ["混凝土数据库", "http://111.42.226.70:8077/"],
                ["工程内业", "http://111.42.226.70:18000/"],
                ["六项机制", "https://sanjiang.tuqi.net.cn/#/fourLogin"],
                ["安全生产", "http://www.hljsd.com//oauth2/authorize?response_type=code&client_id=1030&redirect_uri=https://ljsd.bosafe.com/default/org.gocom.components.coframe.auth.login.HljsdLogin.flow&scope=code"],
                

            ]),
            // 当前时间
            dateNow: null,
            daysOfWeek: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
            // 弹窗标志位(是否是第三方平台跳转链接)
            isWebsite: false,
            // 产值月份数据
            monthData: [],
            // 权属单位统计
            companyData: [],
            // 当前选中的理念列表
            avtiveDreamItem: "FIRST",
            dialogInfo: {
                opening: false
            },
            dreamDialogInfo: {
                isOpening: false,
                dreamId: null
            }
        }
    },
    mounted() {
        // DOM发生尺寸变化时，重新计算根节点字号
        window.addEventListener("resize", this.resetRootNodeFontSizeHandler);
        this.resetRootNodeFontSizeHandler();
        // 背景雨滴效果
        this.startBackgroundRain();

        // 中心区域线段效果
        this.startDashedLine();

        // 启动智慧树
        this.startVideo();

        // 智慧果鼠标悬浮，停止所有动画
        let appleList = ["appleKeChuangRef", "appleJingYingRef", "appleZiYuanRef", "appleAnQuanRef"];
        for (let index = 0; index < appleList.length; index++) {
            this.$refs[appleList[index]].addEventListener("mouseover", () => {
                appleList.forEach(item => {
                    this.$refs[item].style.animationPlayState = "paused";
                });
            });
            this.$refs[appleList[index]].addEventListener("mouseout", () => {
                appleList.forEach(item => {
                    this.$refs[item].style.animationPlayState = "running";
                });
            });
        }

        // 绘制弹窗图表
        this.dwChartPie1Instance = Echarts.init(this.$refs["dialogChartPie1Ref"]);
        this.dwChartPie2Instance = Echarts.init(this.$refs["dialogChartPie2Ref"]);
        this.dwChartPie3Instance = Echarts.init(this.$refs["dialogChartPie3Ref"]);
        this.dwChartBarInstance = Echarts.init(this.$refs["dialogChartBarRef"]);
        this.dwChartLineInstance = Echarts.init(this.$refs["dialogChartLineRef"]);

        // 弹窗图表(本地)
        this.currentChartRefInstance = Echarts.init(this.$refs["currentChartRef"]);
        // 弹窗图表(本地-补充图表)
        this.replenishmentChartRefInstance = Echarts.init(this.$refs["replenishmentChartRef"]);

        // 区域项目建设情况统计
        this.awardInfoPanelInstance = Echarts.init(this.$refs["awardInfoPanelRef"]);

        // 获取星期几
        let dayOfWeek = this.daysOfWeek[new Date().getDay()];

        // 当前时间
        this.dateTimerFlag = setInterval(() => {
            let now = new Date();
            let year = now.getFullYear();
            let month = `${(now.getMonth() + 1)}`.length === 1 ? `0${(now.getMonth() + 1)}` : (now.getMonth() + 1);
            let day = `${now.getDate()}`.length === 1 ? `0${now.getDate()}` : now.getDate();
            let hour = `${now.getHours()}`.length === 1 ? `0${now.getHours()}` : now.getHours();
            let min = `${now.getMinutes()}`.length === 1 ? `0${now.getMinutes()}` : now.getMinutes();
            let sen = `${now.getSeconds()}`.length === 1 ? `0${now.getSeconds()}` : now.getSeconds();
            this.dateNow = `${year}-${month}-${day} ${hour}:${min}:${sen}   ${dayOfWeek}`;
        }, 900);

        // 加载汇总数据
        this.getTotalStatistics();
        // this.$nextTick(() => {
        //     this.awardInfoPanelInstance.setOption(this.placeProjectStastists());
        //     this.awardInfoPanelInstance.resize();
        // });
    },
    methods: {
        /**
         * 获取汇总统计数据
         */
        getTotalStatistics() {
            axios.get('http://121.36.58.3:8890/business/bigScreen/queryCockpitDatas').then(
                (res) => {
                    try {
                        if (res.data.status && res.data.status.code && res.data.status.code === "0") {
                            let dataArray = res.data.data;
                            if (dataArray != null && Array.isArray(dataArray)) {
                                let countList = [];
                                let moneyList = [];
                                this.projectTypeList = [];
                                let indexId = 1;
                                dataArray.forEach(
                                    (item) => {
                                        // 年度汇总统计
                                        if (["IND_000001", "IND_000002", "IND_000003", "IND_000004"].includes(item.idxId)) {
                                            this.totalAmountInfo[item.idxId] = parseInt(item.idxValue).toLocaleString("en-US");
                                        }
                                        // 项目数量
                                        else if (item.idxId === "IND_000006") {
                                            countList.push(parseInt(item.idxValue));
                                        }
                                        // 项目金额
                                        else if (item.idxId === "IND_000007") {
                                            moneyList.push(parseInt(item.idxValue));
                                        }
                                        // 中标项目分类
                                        else if (item.idxId === "IND_000005") {
                                            // idxDimensionName
                                            this.projectTypeList.push({
                                                id: indexId,
                                                label: item.idxDimensionName,
                                                value: item.idxValue
                                            });
                                            indexId++;
                                        }
                                        else if (item.idxId === 'IND_000016') {
                                            this.monthData.push(item);
                                        }
                                        else if (item.idxId === 'IND_000017') {
                                            this.companyData.push(item);
                                        }
                                    }
                                );
                                // 处理顺序
                                this.projectTypeList.sort(
                                    (a, b) => {
                                        return b.value - a.value;
                                    }
                                );
                                const option = {
                                    legend: [
                                        {
                                            // 图例
                                            top: '5%',
                                            left: 'center', // 图例距离左侧距离(此处水平居中)
                                            textStyle: {
                                                // 图例文本样式
                                                color: '#fff',
                                                fontSize: `${parseInt(this.domFontSize * 0.5)}px`
                                            },
                                            itemGap: 100,
                                            icon: 'circle',
                                            selectedMode: false, //图例点击失效
                                            data: ["数量(个)", "金额(万元)"],
                                        }
                                    ],
                                    tooltip: {
                                        // 提示框
                                        show: true,
                                        trigger: 'axis',
                                        axisPointer: {
                                            // 坐标轴指示器配置项。
                                            type: 'shadow'
                                        },
                                    },
                                    grid: [
                                        {
                                            // 左边
                                            show: false,
                                            left: '0%',
                                            top: 30,
                                            bottom: 10,
                                            containLabel: true,
                                            width: '38%',
                                        },
                                        {
                                            // 中间
                                            show: false,
                                            left: '52%',
                                            top: 30,
                                            bottom: 10,
                                            width: '24%',
                                        },
                                        {
                                            // 右边
                                            show: false,
                                            right: '10%',
                                            top: 30,
                                            bottom: 10,
                                            containLabel: true,
                                            width: '38%',
                                        },
                                    ],
                                    // X轴线配置
                                    xAxis: [
                                        {
                                            // 左侧区域
                                            gridIndex: 0, // x 轴所在的 grid 的索引，默认位于第一个 grid。[ default: 0 ]
                                            type: 'value', // 轴线类型: 数值轴
                                            position: 'top', // 轴线位置(此处位于顶部)
                                            inverse: true, // 是否是反向坐标轴.[ default: false ]
                                            axisLine: {
                                                show: false, // 轴线不显示
                                            },
                                            axisTick: {
                                                show: false, // 轴线刻度不显示
                                            },
                                            axisLabel: {
                                                // 轴线刻度标签
                                                show: false, // 显示刻度标签
                                                textStyle: {
                                                    // 标签样式
                                                    color: '#153D7D64',
                                                    // fontSize: 12,
                                                    fontSize: `${parseInt(this.domFontSize * 0.5)}px`
                                                },
                                            },
                                            splitLine: {
                                                // 垂直于X轴的分隔线
                                                show: true, // 显示分隔线
                                                lineStyle: {
                                                    // 分隔线样式
                                                    color: '#153D7D64',
                                                    width: 1,
                                                    type: 'solid',
                                                },
                                            },
                                        },
                                        {
                                            // 中间区域
                                            gridIndex: 1,
                                            show: false, // 中间部分不显示X轴
                                        },
                                        {
                                            // 右侧区域
                                            gridIndex: 2,
                                            type: 'value',
                                            position: 'top',
                                            inverse: false, // 是否是反向坐标轴.[ default: false ]
                                            axisLine: {
                                                show: false,
                                            },
                                            axisTick: {
                                                show: false,
                                            },
                                            axisLabel: {
                                                show: false,
                                                textStyle: {
                                                    color: '#153D7D64',
                                                    // fontSize: 12,
                                                    fontSize: `${parseInt(this.domFontSize * 0.5)}px`
                                                },
                                            },
                                            splitLine: {
                                                show: true,
                                                lineStyle: {
                                                    color: '#153D7D64',
                                                    width: 1,
                                                    type: 'solid',
                                                },
                                            },
                                        },
                                    ],
                                    // Y轴线配置
                                    yAxis: [
                                        {
                                            // 左侧区域
                                            gridIndex: 0, // y 轴所在的 grid 的索引，默认位于第一个 grid。[ default: 0 ]
                                            type: 'category', // 轴线类型: 类目轴
                                            // 类目轴中 boundaryGap 可以配置为 true 和 false。默认为 true，这时候刻度只是作为分隔线，标签和数据点都会在两个刻度之间的带(band)中间。
                                            boundaryGap: true, // 坐标轴两边留白策略，类目轴和非类目轴的设置和表现不一样。
                                            inverse: true, // 是否是反向坐标轴.[ default: false ]
                                            position: 'right', // y轴的位置。'left' or 'right'
                                            axisLine: {
                                                show: false, // y轴线不显示
                                            },
                                            axisTick: {
                                                show: false, // y轴线刻度不显示
                                                lineStyle: {
                                                    // 刻度线样式
                                                    color: '#11356D',
                                                },
                                            },
                                            axisLabel: {
                                                show: false, // 刻度标签不显示
                                            },
                                            data: ["省内新建", "省内续建", "省外新建", "省外续建"], // Y轴(这里是类目轴)的类目数据
                                        },
                                        {
                                            gridIndex: 1, // 中间区域
                                            type: 'category',
                                            boundaryGap: true,
                                            inverse: true,
                                            position: 'left', // y轴的位置。'left' or 'right'
                                            axisLine: {
                                                show: false,
                                            },
                                            axisTick: {
                                                show: false,
                                            },
                                            axisLabel: {
                                                show: true, // 显示中间部分的Y轴刻度标签(中间的文字)
                                                textStyle: {
                                                    // 标签样式
                                                    color: '#cccccc',
                                                    fontSize: `${parseInt(this.domFontSize * 0.6)}px`
                                                },
                                            },
                                            data: ["省内新建", "省内续建", "省外新建", "省外续建"],
                                        },
                                        {
                                            // 右侧区域
                                            gridIndex: 2,
                                            type: 'category',
                                            boundaryGap: true,
                                            inverse: true,
                                            position: 'left',
                                            axisLine: {
                                                show: false,
                                            },
                                            axisTick: {
                                                show: false,
                                                lineStyle: {
                                                    // 刻度线样式
                                                    color: '#153D7D',
                                                },
                                            },
                                            axisLabel: {
                                                show: false,
                                            },
                                            data: ["省内新建", "省内续建", "省外新建", "省外续建"],
                                        },
                                    ],
                                    series: [
                                        {
                                            name: "数量(个)", // 系列名称
                                            type: 'bar',
                                            barGap: 35, // 柱间距离
                                            barWidth: 20, // 柱子宽度
                                            xAxisIndex: 0, // 对应在X轴的grid索引
                                            yAxisIndex: 0, // 对应在Y轴的grid索引
                                            label: {
                                                show: true,
                                                position: 'left',
                                                color: '#fff',
                                                fontSize: `${parseInt(this.domFontSize * 0.5)}px`
                                            },
                                            itemStyle: {
                                                // 柱条样式。
                                                color: "#f29701"
                                            },
                                            emphasis: {
                                                // 鼠标指向高亮
                                                show: true,
                                            },
                                            data: countList, // 系列中的数据内容数组
                                        },
                                        {
                                            name: "金额(万元)", // 系列名称
                                            type: 'bar',
                                            barGap: 35, // 柱间距离
                                            barWidth: 20, // 柱子宽度
                                            xAxisIndex: 2, // 对应在X轴的grid索引
                                            yAxisIndex: 2, // 对应在Y轴的grid索引
                                            label: {
                                                show: true,
                                                position: 'right',
                                                color: '#fff',
                                                fontSize: `${parseInt(this.domFontSize * 0.5)}px`
                                            },
                                            itemStyle: {
                                                // 柱条样式。
                                                color: "#09828c"
                                            },
                                            emphasis: {
                                                // 鼠标指向高亮
                                                show: true,
                                            },
                                            // data: [939800, 641478, 70759, 154818]// moneyList, // 系列中的数据内容数组
                                            data: moneyList, // 系列中的数据内容数组
                                        }
                                    ]
                                };
                                this.$nextTick(() => {
                                    this.awardInfoPanelInstance.setOption(option);
                                    this.awardInfoPanelInstance.resize();
                                });

                                // 启动颜色循环动画
                                this.startTopColor();
                            }
                        }
                    }
                    catch (err) {
                        console.log(`统计数据解析失败: ${new Date().toLocaleString()}----${err}`);
                    }
                },
                (err) => {
                    // 失败就失败，手动刷新浏览器就是了
                    console.log(`数据加载请求失败: ${new Date().toLocaleString()}----${err}`);
                }
            );
        },
        /**
         * 页面尺寸变化
         */
        resetRootNodeFontSizeHandler() {
            // 重新定义DOM根元素字号
            let w = document.documentElement.clientWidth / 80;
            document.documentElement.style.fontSize = `${w}px`;
            this.domFontSize = w;

            // 重置雨滴画布大小
            if (this.$refs["bkRainCanvasRef"]) {
                this.$refs["bkRainCanvasRef"].width = document.body.clientWidth;
                this.$refs["bkRainCanvasRef"].height = document.body.clientHeight;
            }

            // 重置线段效果位置
            this.startDashedLine();

            // 重置奖牌信息饼图大小
            if (this.awardChartInstance) {
                this.awardChartInstance.resize();
            }

            // 区域项目建设情况
            if (this.awardInfoPanelInstance) {
                try {
                    let option = this.awardInfoPanelInstance.getOption();
                    option.legend[0].textStyle.fontSize = `${parseInt(this.domFontSize * 0.5)}px`;
                    option.xAxis[0].axisLabel.textStyle.fontSize = `${parseInt(this.domFontSize * 0.5)}px`;
                    option.xAxis[2].axisLabel.textStyle.fontSize = `${parseInt(this.domFontSize * 0.5)}px`;
                    option.yAxis[1].axisLabel.textStyle.fontSize = `${parseInt(this.domFontSize * 0.5)}px`;
                    option.series[0].label.fontSize = `${parseInt(this.domFontSize * 0.5)}px`;
                    option.series[1].label.fontSize = `${parseInt(this.domFontSize * 0.5)}px`;
                    this.awardInfoPanelInstance.setOption(option);
                    this.awardInfoPanelInstance.resize();
                }
                // eslint-disable-next-line no-empty
                catch (e) { }
            }
        },
        /**
         * 启动颜色循环动画
         */
        startTopColor() {
            if (this.timerFlag != null) {
                clearInterval(this.timerFlag);
                this.timerFlag = null;
            }
            this.timerFlag = setInterval(() => {
                if (this.activeItemId > this.projectTypeList.length - 1) {
                    this.activeItemId = 1;
                }
                else {
                    this.activeItemId++;
                }
            }, 3000);
        },
        /**
         * 时钟切换颜色
         */
        activeStyleText(itemId, domType) {
            if (this.activeItemId === itemId) {
                if (domType === 'content') {
                    return `
                        background: url('${BORDER2_IMG}') center center / contain no-repeat;
                        backgroundSize: 'contain';
                    `
                }
                else {
                    return `
                        background: url('${ORANGE_IMG}') center center / 100% no-repeat;
                        backgroundSize: '100%';
                    `
                }
            }
        },
        /**
         * 背景雨滴效果
         */
        startBackgroundRain() {
            // 初始化画布宽高
            let c = this.$refs["bkRainCanvasRef"];
            let w = c.width = document.body.clientWidth;
            let h = c.height = document.body.clientHeight;
            let ctx = this.$refs["bkRainCanvasRef"].getContext("2d");
            function random(min, max) {
                return Math.random() * (max - min) + min;
            }
            function RainDrop() { }
            //雨滴对象 这是绘制雨滴动画的关键
            RainDrop.prototype = {
                init: function () {
                    this.x = random(0, w);//雨滴的位置x
                    this.y = h;//雨滴的位置y
                    this.color = 'hsl(180, 100%, 50%)';//雨滴颜色 长方形的填充色
                    this.vy = random(4, 5);//雨滴下落速度
                    this.hit = 0;//下落的最大值
                    this.size = 3;//长方形宽度
                },
                draw: function () {
                    if (this.y > this.hit) {
                        var linearGradient = ctx.createLinearGradient(this.x, this.y, this.x, this.y + this.size * 30)
                        // 设置起始颜色
                        linearGradient.addColorStop(0, 'rgba(4, 58, 63,1)')
                        // 设置终止颜色
                        linearGradient.addColorStop(1, 'rgba(4, 58, 63,0.3)')
                        // 设置填充样式
                        ctx.fillStyle = linearGradient
                        ctx.fillRect(this.x, this.y, this.size, this.size * 20);//绘制长方形，通过多次叠加长方形，形成雨滴下落效果
                    }
                    this.update();//更新位置
                },
                update: function () {
                    if (this.y > this.hit) {
                        this.y -= this.vy;//未达到底部，增加雨滴y坐标
                    } else {
                        this.init();
                    }
                }
            };
            let rs = []
            for (let i = 0; i < 10; i++) {
                setTimeout(function () {
                    let r = new RainDrop();
                    r.init();
                    rs.push(r);
                }, i * 300)
            }

            function anim() {
                ctx.clearRect(0, 0, w, h);//填充背景色，注意不要用clearRect，否则会清空前面的雨滴，导致不能产生叠加的效果
                for (let i = 0; i < rs.length; i++) {
                    rs[i].draw();//绘制雨滴
                }
                requestAnimationFrame(anim);//控制动画帧
            }
            function resize() {
                w = c.width = window.innerWidth;
                h = c.height = window.innerHeight;
            }
            window.addEventListener("resize", resize);
            anim();
        },
        /**
         * 中心区域线段效果
         */
        startDashedLine() {
            try {
                let ctx = this.$refs["dashedCanvasRef"].getContext('2d');
                let w = this.$refs["dashedCanvasRef"].width = this.$refs["totalPanelRef"].clientWidth;
                let h = this.$refs["dashedCanvasRef"].height = this.$refs["totalPanelRef"].clientHeight / 3 * 2;
                ctx.lineWidth = 3;
                ctx.setLineDash([3, 3]);
                ctx.fillStyle = '#93f8fb'
                ctx.shadowOffsetX = 0;
                // 阴影的y偏移
                ctx.shadowOffsetY = 0;
                // 阴影颜色
                ctx.shadowColor = '#93f8fb';
                // 阴影的模糊半径
                ctx.shadowBlur = 15;
                ctx.save(); //缓存初始状态
                // 绘制第一条曲线
                ctx.beginPath();
                let grd = ctx.createLinearGradient(w / 11 * 2, h / 3, w / 5 * 2, h);
                grd.addColorStop(0, "#54e2e6");
                grd.addColorStop(1, "#065261");
                ctx.strokeStyle = grd;
                ctx.moveTo(w / 5 * 2, h)
                ctx.quadraticCurveTo(w / 5, h / 6 * 5, w / 11 * 2, h / 3);
                ctx.stroke();
                // 绘制第一条曲线上的圆光效果
                ctx.beginPath()
                ctx.moveTo(w / 11 * 2, h / 3)
                ctx.arc(w / 11 * 2, h / 3, 5, 0, Math.PI * 2)
                ctx.fill()
                ctx.restore()
                ctx.save()
                // 绘制第二条线
                ctx.beginPath()
                grd = ctx.createLinearGradient(w / 11 * 3.3, h / 2, w / 3 * 1.1, h / 6 * 5);
                grd.addColorStop(0, "#e08d03");
                grd.addColorStop(1, "#2e6a5c");
                ctx.strokeStyle = grd;
                ctx.moveTo(w / 3 * 1.1, h / 6 * 5)
                ctx.quadraticCurveTo(w / 5 * 1.5, h / 6 * 4.2, w / 11 * 3.3, h / 2);
                ctx.stroke();
                // 绘制第二条曲线上的圆光效果
                ctx.beginPath()
                ctx.moveTo(w / 11 * 3.3, h / 2)
                ctx.arc(w / 11 * 3.3, h / 2, 5, 0, Math.PI * 2)
                ctx.fill()
                ctx.restore()
                ctx.save()
                // 绘制第三条线
                ctx.beginPath()
                grd = ctx.createLinearGradient(w / 3 * 1.4, h / 5, w / 5 * 2, h / 2);
                grd.addColorStop(0, "#e08d03");
                grd.addColorStop(1, "#2e6a5c");
                ctx.strokeStyle = grd;
                ctx.moveTo(w / 5 * 2, h / 2)
                ctx.quadraticCurveTo(w / 3 * 1.2, h / 4 * 1.4, w / 3 * 1.4, h / 5);
                ctx.stroke();
                // 绘制第三条曲线上的圆光效果
                ctx.beginPath()
                ctx.moveTo(w / 3 * 1.4, h / 5)
                ctx.arc(w / 3 * 1.4, h / 5, 5, 0, Math.PI * 2)
                ctx.fill()
                ctx.restore()
                ctx.save()
                // 绘制第四条线
                ctx.beginPath()
                grd = ctx.createLinearGradient(w / 5 * 3.1, h / 3 * 1.2, w / 5 * 3.2, h / 2 * 1.5);
                grd.addColorStop(0, "#e08d03");
                grd.addColorStop(1, "#2e6a5c");
                ctx.strokeStyle = grd;
                ctx.moveTo(w / 5 * 3.2, h / 2 * 1.5)
                ctx.quadraticCurveTo(w / 5 * 3.35, h / 2 * 1.2, w / 5 * 3.1, h / 3 * 1.2);
                ctx.stroke();
                // 绘制第四条曲线上的圆光效果
                ctx.beginPath()
                ctx.moveTo(w / 5 * 3.1, h / 3 * 1.2)
                ctx.arc(w / 5 * 3.1, h / 3 * 1.2, 5, 0, Math.PI * 2)
                ctx.fill()
                ctx.restore()
                ctx.save()
                // 绘制第五条线
                ctx.beginPath()
                grd = ctx.createLinearGradient(w / 5 * 3.3, h / 4, w / 5 * 3.2, h / 2 * 1.9);
                grd.addColorStop(0, "#e08d03");
                grd.addColorStop(1, "#2e6a5c");
                ctx.strokeStyle = grd;
                ctx.moveTo(w / 5 * 3.03, h / 2 * 1.9)
                ctx.quadraticCurveTo(w / 5 * 3.8, h / 2 * 1.2, w / 5 * 3.3, h / 4);
                ctx.stroke();
                // 绘制第五条曲线上的圆光效果
                ctx.beginPath()
                ctx.moveTo(w / 5 * 3.3, h / 4)
                ctx.arc(w / 5 * 3.3, h / 4, 5, 0, Math.PI * 2)
                ctx.fill()
                ctx.restore()
                ctx.save()
                // 绘制第六条线
                ctx.beginPath()
                grd = ctx.createLinearGradient(w / 5 * 3.8, h / 2 * 1.2, w / 5 * 2.9, h);
                grd.addColorStop(0, "#e08d03");
                grd.addColorStop(1, "#2e6a5c");
                ctx.strokeStyle = grd;
                ctx.moveTo(w / 5 * 2.9, h)
                ctx.quadraticCurveTo(w / 5 * 3.7, h / 2 * 1.6, w / 5 * 3.8, h / 2 * 1.2);
                ctx.stroke();
                // 绘制第六条曲线上的圆光效果
                ctx.beginPath()
                ctx.moveTo(w / 5 * 3.8, h / 2 * 1.2)
                ctx.arc(w / 5 * 3.8, h / 2 * 1.2, 5, 0, Math.PI * 2)
                ctx.fill()
            }
            // eslint-disable-next-line no-empty
            catch { }
        },
        /**
         * 初始化并开始播放视频(智慧树)
         */
        startVideo() {
            // 初始化智慧树
            if (this.$refs["mVideoRef"]) {
                this.$refs["mVideoRef"].addEventListener("ended", this.videoPlayEnd);
                this.$refs["mVideoRef"].addEventListener('timeupdate', this.repeatPlayVideo);
                this.$refs["mVideoRef"].muted = true;
                this.$refs["mVideoRef"].autoplay = true;
                this.$refs["mVideoRef"].controls = false;
            }
            else {
                console.log(`视频启动失败: ${new Date().toLocaleString()}`);
            }
        },
        /**
         * 重复播放指定时间范围的视频帧
         */
        repeatPlayVideo() {
            try {
                if (this.$refs["mVideoRef"]) {
                    if (this.$refs["mVideoRef"].currentTime >= this.endTime && this.hasPlayed) {
                        // 重置当前时间到起始时间
                        this.$refs["mVideoRef"].currentTime = this.startTime;
                        setTimeout(() => {
                            this.$refs["mVideoRef"].play();
                        }, 500);
                    }
                }
            }
            catch (err) {
                console.log(`播放视频帧: ${err}`, new Date().toLocaleString());
            }
        },
        /**
         * 视频播放结束回调函数
         */
        videoPlayEnd() {
            try {
                if (this.$refs["mVideoRef"]) {
                    if (!this.hasPlayed) {
                        this.hasPlayed = true;
                        this.repeatPlayVideo();
                    }
                    else {
                        // 从指定起始时间开始
                        this.$refs["mVideoRef"].currentTime = this.startTime;
                        setTimeout(() => {
                            this.$refs["mVideoRef"].play(); // 开始播放
                        }, 500);
                    }
                }
            }
            catch (err) {
                console.log(`结束视频帧: ${err}`, new Date().toLocaleString());
            }
        },
        /**
         * 获取指定范围的随机数
         * @param min 最小值
         * @param max 最大值
         * @param decimals 保留的小数位
         * @param format 格式方式
         */
        getRangeRandom(min, max, format = "en-US") {
            let random = Math.random() * (max - min) + min;
            return format === "en-US" ? parseInt(random).toLocaleString() : parseInt(random);
        },
        /**
         * 打开跳转弹窗
         * @param isShow 
         * @param website 新增参数：用于区分要显示的内容
         */
        showDialog(isShow = true, website = "") {
            if (isShow) {
                this.$refs["dialogWindowRef"].style.animation = 'dialogWindowOpen 0.5s forwards normal';
                let option = null;
                let optionOther = null;
                try {
                    switch (website) {
                        case "中标项目分类": {
                            this.activeDialogWebsiteName = "中标项目分类统计";
                            this.isWebsite = false;// 非第三方平台跳转链接
                            let xArray = [];
                            let dataArray = [];
                            let percentArray = [];
                            let count = new Decimal("0");// 中标项目总数
                            this.projectTypeList.forEach(
                                (item) => {
                                    xArray.push(item.label);
                                    dataArray.push(item.value);
                                    count = count.plus(new Decimal(item.value));
                                }
                            );
                            dataArray.forEach(
                                (item) => {
                                    if (count.eq(new Decimal("0"))) {
                                        percentArray.push(0);
                                        console.log(1);
                                    }
                                    else {
                                        let precent = new Decimal(item).dividedBy(count);
                                        precent = precent.times(new Decimal("100"));
                                        percentArray.push(new Decimal(precent.toFixed(2)).toNumber());
                                    }
                                });
                            option = {
                                tooltip: {
                                    trigger: 'axis',
                                    axisPointer: {
                                        type: 'cross',
                                        crossStyle: {
                                            color: '#999'
                                        }
                                    }
                                },
                                legend: {
                                    data: ['数量(个)', '占比(%)'],
                                    textStyle: {
                                        fontSize: '12px',
                                        color: '#ffffff'
                                    }
                                },
                                xAxis: [
                                    {
                                        type: 'category',
                                        data: xArray,
                                        axisPointer: {
                                            type: 'shadow'
                                        },
                                        // x轴文字颜色
                                        axisLabel: {
                                            show: true,
                                            textStyle: {
                                                fontSize: '12px',
                                                color: '#ffffff'
                                            }
                                        },
                                        //x轴刻度线颜色
                                        axisLine: {
                                            show: false,
                                            lineStyle: {
                                                color: '#0e2c52',
                                                width: 1
                                            }
                                        }
                                    }
                                ],
                                yAxis: [
                                    {
                                        type: 'value',
                                        min: 0,
                                        max: 250,
                                        interval: 50,
                                        axisLabel: {
                                            formatter: '{value} 个',
                                            textStyle: {
                                                fontSize: '12px',
                                                color: '#ffffff'
                                            }
                                        }
                                    },
                                    {
                                        type: 'value',
                                        min: 0,
                                        max: 100,
                                        interval: 20,
                                        axisLabel: {
                                            formatter: '{value} %',
                                            textStyle: {
                                                fontSize: '12px',
                                                color: '#ffffff'
                                            }
                                        }
                                    }
                                ],
                                series: [
                                    {
                                        name: '数量(个)',
                                        type: 'bar',
                                        tooltip: {
                                            valueFormatter: function (value) {
                                                return value + ' 个';
                                            }
                                        },
                                        itemStyle: {
                                            normal: {
                                                color: 'rgb(242, 151, 1)'
                                            }
                                        },
                                        data: dataArray
                                    },
                                    {
                                        name: '占比(%)',
                                        type: 'line',
                                        yAxisIndex: 1,
                                        areaStyle: {
                                            normal: {
                                                color: 'rgba(79,237,247,0.3)'
                                            }
                                        },
                                        itemStyle: {
                                            normal: {
                                                lineStyle: {
                                                    color: '#00dafb',
                                                    width: 1
                                                },
                                                color: '#00dafb'
                                            }
                                        },
                                        tooltip: {
                                            valueFormatter: function (value) {
                                                return value + ' %';
                                            }
                                        },
                                        data: percentArray
                                    }
                                ]
                            }
                            break;
                        }
                        // 各月份产值情况统计
                        case "完成产值总额": {
                            this.activeDialogWebsiteName = "产值情况统计";
                            this.isWebsite = false;// 非第三方平台跳转链接
                            let mArray = [];
                            let dataArray = [];
                            this.monthData.forEach(
                                (item) => {
                                    mArray.push(item.idxDimensionName);
                                    dataArray.push(new Decimal(item.idxValue).toFixed(2));
                                }
                            );
                            option = {
                                tooltip: {
                                    trigger: 'axis',
                                    axisPointer: {
                                        type: 'cross',
                                        label: {
                                            backgroundColor: '#6a7985'
                                        }
                                    }
                                },
                                legend: {
                                    data: ['产值(万元)'],
                                    textStyle: {
                                        fontSize: '12px',
                                        color: '#ffffff'
                                    }
                                },
                                grid: {
                                    left: '3%',
                                    right: '4%',
                                    bottom: '3%',
                                    containLabel: true
                                },
                                xAxis: [
                                    {
                                        type: 'category',
                                        boundaryGap: false,
                                        axisLabel: {
                                            show: true,
                                            textStyle: {
                                                fontSize: '12px',
                                                color: '#ffffff'
                                            }
                                        },
                                        data: mArray
                                    }
                                ],
                                yAxis: [
                                    {
                                        type: 'value',
                                        axisLabel: {
                                            show: true,
                                            formatter: '{value} 万元',
                                            textStyle: {
                                                fontSize: '12px',
                                                color: '#ffffff'
                                            }
                                        }
                                    }
                                ],
                                series: [
                                    {
                                        name: '产值(万元)',
                                        type: 'line',
                                        stack: 'Total',
                                        emphasis: {
                                            focus: 'series'
                                        },
                                        areaStyle: {
                                            normal: {
                                                color: 'rgba(79,237,247,0.3)'
                                            }
                                        },
                                        itemStyle: {
                                            normal: {
                                                lineStyle: {
                                                    color: '#00dafb',
                                                    width: 1
                                                },
                                                color: '#00dafb'
                                            }
                                        },
                                        tooltip: {
                                            valueFormatter: function (value) {
                                                return value + ' 万元';
                                            }
                                        },
                                        data: dataArray
                                    }
                                ]
                            };
                            let dArray = [];
                            let nArray = [];
                            this.companyData.forEach(
                                (item) => {
                                    if (item.idxDimensionName !== "集团") {
                                        nArray.push(item.idxDimensionName);
                                        dArray.push(new Decimal(new Decimal(item.idxValue).toFixed(2)).toNumber());
                                    }
                                }
                            );

                            // 各权属单位统计
                            optionOther = {
                                angleAxis: {
                                    type: 'category',
                                    // x轴文字颜色
                                    axisLabel: {
                                        show: true,
                                        textStyle: {
                                            fontSize: '12px',
                                            color: '#ffffff'
                                        }
                                    },
                                    data: nArray
                                },
                                radiusAxis: {
                                    axisLabel: {
                                        show: true,
                                        textStyle: {
                                            fontSize: '12px',
                                            color: '#ffffff'
                                        }
                                    }
                                },
                                polar: {},
                                series: [
                                    {
                                        type: 'bar',
                                        data: dArray,
                                        coordinateSystem: 'polar',
                                        name: '各权属单位产值',
                                        itemStyle: {
                                            normal: {
                                                color: '#00dafb'
                                            }
                                        },
                                        stack: 'a',
                                        emphasis: {
                                            focus: 'series',
                                            itemStyle: {
                                                color: 'rgba(0, 218, 251,0.5)' // 当鼠标悬浮在系列上时的颜色变化，可根据需求调整
                                            },
                                            label: {
                                                show: false
                                            }
                                        }
                                    }
                                ],
                                tooltip: {
                                    trigger: 'axis',
                                    axisPointer: {
                                        type: 'shadow'
                                    },
                                    valueFormatter: function (value) {
                                        return value + ' 万元';
                                    }
                                },
                                legend: {
                                    show: true,
                                    textStyle: {
                                        fontSize: '12px',
                                        color: '#ffffff'
                                    },
                                    data: ['各权属单位产值']
                                }
                            }
                            break;
                        }
                        // 近年收入利润变化
                        case "利润总额": {
                            this.activeDialogWebsiteName = "近年收入利润变化";
                            this.isWebsite = false;// 非第三方平台跳转链接
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                }
                catch (e) {
                    console.error("加载数据失败: ", e);
                }
                // 这不优化了，后续可能还会大改
                if (option != null) {
                    this.currentChartRefInstance.clear();
                    if (optionOther != null) {
                        this.replenishmentChartRefInstance.clear();
                    }
                    setTimeout(() => {
                        this.currentChartRefInstance.setOption(option);
                        this.currentChartRefInstance.resize();

                        // 只有产值时，才使用到了此图表
                        if (optionOther != null) {
                            this.replenishmentChartRefInstance.setOption(optionOther);
                            this.replenishmentChartRefInstance.resize();
                        }
                    }, 800);
                }
            }
            else {
                this.$refs["dialogWindowRef"].style.animation = "";
                this.$refs["dialogWindowRef"].style.width = "0px";
                this.$refs["dialogWindowRef"].style.height = "0px";
            }
        },
        /**
         * 区域项目建设情况图表
         */
        placeProjectStastists() {
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                    }
                },
                legend: {
                    itemGap: 20,
                    orient: 'horizontal', // 水平布局
                    left: '0%', // 水平居中center
                    textStyle: {
                        color: '#ffffff',
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#ffffff'
                        }
                    }
                },
                yAxis: {
                    type: 'category',
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false // 不显示刻度线
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#ffffff'
                        }
                    },
                    data: ['省内新建', '省内续建', '省外新建', '省外续建']
                },
                series: [
                    {
                        name: '数量(个)',
                        type: 'bar',
                        stack: 'total',
                        label: {
                            show: true
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            color: {
                                type: 'linear',
                                x: 0, // 右
                                y: 0, // 下
                                x2: 1, // 左
                                y2: 0, // 上
                                colorStops: [
                                    {
                                        offset: 0.1,
                                        color: 'rgba(8, 195, 202,0.1)' // 100% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(8, 195, 202,1)' // 0% 处的颜色
                                    }
                                ],
                                global: false //设置为false 使得渐变色不受全局影响
                            },
                            borderRadius: [0, 0, 0, 0] // 设置圆角半径
                        },
                        data: [320, 302, 301, 334, 390, 330, 320]
                    },
                    {
                        name: '金额(万元)',
                        type: 'bar',
                        stack: 'total',
                        label: {
                            show: true
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            color: {
                                type: 'linear',
                                x: 1, // 右
                                y: 0, // 下
                                x2: 0, // 左
                                y2: 0, // 上
                                colorStops: [
                                    {
                                        offset: 0.1,
                                        color: 'rgb(196, 127, 10,1) ' // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgb(196, 127, 10,0.1)' // 100% 处的颜色
                                    }
                                ]
                            },
                            borderRadius: [0, 0, 0, 0] // 设置圆角半径,
                        },
                        data: [820, 832, 901, 934, 1290, 1330, 1320]
                    }
                ]
            };
            return option;
        },
        /**
         * 跳转到其它平台
         * @param websiteZh 平台中文名称
         */
        pushToOtherWebSiteHandler(websiteZh, isJumpNow = false) {
            // 暂时先全部跳转
            isJumpNow = true;

            this.activeDialogWebsiteName = websiteZh;
            if (!isJumpNow) {
                this.showDialog();
            }
            else {
                // 特殊处理: 机物料联
                if (websiteZh === '机物料联') {
                    this.showBtnDialogHandler(null, true);
                    return;
                }
                // 特殊处理: 资料整编
                if (websiteZh === '资料整编') {
                    this.showBtnDialog2Handler(null, true);
                    return;
                }
                // 特殊处理: 数据监管
                if (websiteZh === '安全管理') {
                    this.showBtnDialog3Handler(null, true);
                    return;
                }
                if (this.websiteHrefMap.has(websiteZh)) {
                    let websiteHref = this.websiteHrefMap.get(websiteZh);
                    if ((websiteHref ?? "") === "") {
                        alert("系统正在建设中...");
                        return;
                    }
                    // 按钮组特殊处理
                    if (websiteZh === '资源管理' || websiteZh === '收发料管理') {
                        this.showBtnDialogHandler(null, false);
                    }
                    // 直接跳转到其它平台
                    window.open(websiteHref, "_blank");
                }
            }
        },
        /**
         * 退出登录
         */
        quitOutWebsiteHandler() {
            MessageBox.confirm('退出后将清除登录信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                window.location.replace("http://www.hljsd.com/oauth2/logout");
                // 发起退出请求(懒得写接口了)
                // let xhr = new XMLHttpRequest();
                // xhr.open('GET', 'http://www.hljsd.com/oauth2/logout', true);
                // xhr.setRequestHeader('Content-Type', 'application/json');
                // xhr.send();
                // xhr.onreadystatechange = () => {
                //     if (xhr.readyState === 4 && xhr.status === 200) {
                //         let response = JSON.parse(xhr.responseText);
                //         console.log(response);
                //         localStorage.clear();
                //         this.clearAllCookies();
                //         window.location.reload();
                //     }
                //     else if (xhr.readyState === 4 && xhr.status !== 200) {
                //         console.error('请求失败，状态码：' + xhr.status);
                //         localStorage.clear();
                //         this.clearAllCookies();
                //         window.location.reload();
                //     }
                // };
            }).catch(() => { });
        },
        /**
         * 手动清理全部Cookies信息
         */
        clearAllCookies() {
            let cookies = document.cookie.split(";");
            for (var i = 0; i < cookies.length; i++) {
                let cookie = cookies[i];
                let eqPos = cookie.indexOf("=");
                let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
        },
        /**
         * 按钮组弹窗
         * @param {boolean} [isShow] true
         */
        showBtnDialogHandler(e, isShow = false) {
            if (e && e.target && e.target.className !== "btnDialogWindow") {
                console.log("非父容器");
                return;
            }
            if (this.$refs["btnDialogWindowRef"] == null) {
                return;
            }
            this.$refs["btnDialogWindowRef"].style.width = isShow === true ? "100vw" : "0";
            this.$refs["btnDialogWindowRef"].style.height = isShow === true ? "100vh" : "0";
            this.$refs["btnDialogWindowRef"].style.opacity = isShow === true ? "1" : "0";
        },
        /**
         * 按钮组弹窗
         * @param {boolean} [isShow] true
         */
        showBtnDialog2Handler(e, isShow = false) {
            if (e && e.target && e.target.className !== "btnDialogWindow") {
                console.log("非父容器");
                return;
            }
            if (this.$refs["btnDialogWindowRef"] == null) {
                return;
            }
            this.$refs["btnDialog2WindowRef"].style.width = isShow === true ? "100vw" : "0";
            this.$refs["btnDialog2WindowRef"].style.height = isShow === true ? "100vh" : "0";
            this.$refs["btnDialog2WindowRef"].style.opacity = isShow === true ? "1" : "0";
        },
        /**
         * 按钮组弹窗
         * @param {boolean} [isShow] true
         */
        showBtnDialog3Handler(e, isShow = false) {
            if (e && e.target && e.target.className !== "btnDialogWindow") {
                console.log("非父容器");
                return;
            }
            if (this.$refs["btnDialog3WindowRef"] == null) {
                return;
            }
            this.$refs["btnDialog3WindowRef"].style.width = isShow === true ? "100vw" : "0";
            this.$refs["btnDialog3WindowRef"].style.height = isShow === true ? "100vh" : "0";
            this.$refs["btnDialog3WindowRef"].style.opacity = isShow === true ? "1" : "0";
        },
        /**
         * 打开目标弹窗
         */
        openDreamDialogHandler(dreamId) {
            this.dreamDialogInfo.isOpening = true;
            this.dreamDialogInfo.dreamId = dreamId;
        }
    },
    beforeDestroy() {
        // window.removeEventListener("resize", this.resetRootNodeFontSizeHandler);
        console.log(`已销毁 Resize 事件 , ${new Date().toLocaleString()}`);
        if (this.chartTimerFlag) {
            clearInterval(this.chartTimerFlag);
            this.chartTimerFlag = null;
            console.log(`已销毁 LineChart 时钟 , ${new Date().toLocaleString()}`);
        }
        if (this.timerFlag) {
            clearInterval(this.timerFlag);
            this.timerFlag = null;
            console.log(`已销毁 中标项目 时钟 , ${new Date().toLocaleString()}`);
        }
    }
}
</script>

<style scoped lang="scss">
$titlebg53: "@/assets/53titlebg.png";
$titlepng: "@/assets/title.png";
$borderpng: "@/assets/border.png";
$greenpng: "@/assets/green.png";
$border2png: "@/assets/border2.png";
$orangepng: "@/assets/orange.png";
$circlepng: "@/assets/circle.png";
$gqrightpng53: "@/assets/53gqright.png";
$gqleftpng53: "@/assets/53gqleft.png";
$gqbottomright535png: "@/assets/535gqbottomright.png";
$gqbottomleftpng53: "@/assets/53gqbottomleft.png";
$circle1png: "@/assets/circle1.png";
$circle2png: "@/assets/circle2.png";
$earthpng53: "@/assets/53earth.png";
$cloudpng53: "@/assets/53cloud.png";
$numberpng: "@/assets/2222.png";

@keyframes textShadowInOut {
    from {
        text-shadow: 1px 0 2px #b9f8ff;
    }

    to {
        text-shadow: 1px 0 15px #b9f8ff;
    }
}

@keyframes panelFadeIn {
    from {
        transform: translateY(120%);
    }

    to {
        transform: translateY(0);
    }
}

@keyframes panelFadeInFromLeft {
    from {
        transform: translateX(-120%);
    }

    to {
        transform: translateX(0);
    }
}

@keyframes panelFadeInFromRight {
    from {
        transform: translateX(120%);
    }

    to {
        transform: translateX(0);
    }
}

@keyframes panelFadeInFromTop {
    from {
        transform: translateY(-120%);
    }

    to {
        transform: translateX(0);
    }
}

@keyframes treeHueRouter {
    from {
        filter: hue-rotate(197deg) saturate(1) brightness(1.7);
    }

    to {
        filter: hue-rotate(240deg) saturate(1) brightness(1.7);
    }
}

// 文字跑马灯
@keyframes maskedAnimation {
    0% {
        background-position: 0 0;
    }

    100% {
        background-position: -100% 0;
    }
}

// 组件根节点
.dbRootPanel {
    position: relative;
    width: 100%;
    height: 100%;
    user-select: none;
    background: url('@/assets/53bg.png') no-repeat;
    background-size: 100% 100%;
    background-repeat: no-repeat;


    ul,
    li {
        list-style: none;
    }


    // 头容器
    header {
        height: 12%;
        width: 100%;
        background: url('#{$titlebg53}') no-repeat top center;
        background-size: 100%;
        text-align: center;
        position: relative;
        animation: panelFadeInFromTop 1s ease-in-out 0s forwards;

        // 当前系统时间
        .dateNowPanel {
            position: absolute;
            top: 0px;
            right: 4rem;
            width: auto;
            height: auto;
            font-family: "LCdd";
            font-size: 1rem;
            padding-top: 0.4rem;
            padding-right: 1rem;
            padding-left: 1rem;
            background-image: -webkit-linear-gradient(bottom, #00d7ff, #fff);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        // 退出系统
        .quitBtn {
            font-size: 0.5rem;
            position: absolute;
            top: 0.4rem;
            right: 1rem;
            width: auto;
            height: auto;
            font-family: "LCdd";
            cursor: pointer;
            padding-top: 0.4rem;
            color: #9f9f9f;

            &:hover {
                background-image: -webkit-linear-gradient(bottom, #00d7ff, #fff);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }

        // 企业logo
        .imagePanel {
            position: absolute;
            width: 2.5rem;
            height: 2.5rem;
            left: -25rem;
            right: 0.6rem;
            margin: auto;
            top: 0.3rem;
            display: flex;
            justify-content: center;
            align-items: center;

            >img {
                width: 100%;
            }
        }

        // 跳转业务系统
        >.yeWuWebSite {
            position: absolute;
            width: 1rem;
            height: 1rem;
            right: 2.2rem;
            top: 0.6rem;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            >img {
                width: 100%;
                height: 100%;
            }
        }

        >h1 {
            font-size: 2.3rem;
            height: 50%;
            margin: auto;
            display: table;
            font-weight: 500;

            >span {
                background-image: -webkit-linear-gradient(bottom, #00d7ff, #fff);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                white-space: nowrap;
                writing-mode: horizontal-tb;
                text-orientation: upright;
                animation: textShadowInOut 1.5s linear infinite alternate;
                -webkit-text-stroke: 2px #2e828c;
                text-shadow: 1px 0 5px #b9f8ff;
            }
        }

        >p {
            font-size: 0.8rem;
            background-image: -webkit-linear-gradient(bottom, #00d7ff, #fff);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;

            >span {
                font-size: 0.6rem;
            }
        }
    }

    // 核心区域模块容器
    .main {
        width: 100%;
        height: 78%;
        padding: 0 2.5%;
        box-sizing: border-box;
        position: relative;

        .top5 {
            width: 17.5%;
            height: 70%;
            float: left;
            animation: panelFadeInFromLeft 1s ease-in-out 0s forwards;

            .top5-title {
                width: 100%;
                height: 10%;
                background: url('#{$titlepng}') no-repeat center;
                background-size: 100%;
                color: #fff;
                text-align: center;
                display: table;
                font-size: 0.9rem;

                span {
                    display: table-cell;
                    vertical-align: middle;
                }
            }

            .top5-content {
                width: 100%;
                height: 76%;

                ul {
                    width: 100%;
                    height: 100%;

                    li {
                        width: 100%;
                        height: 15%;
                        margin-top: 5%;
                        position: relative;

                        .li-content {
                            width: 90%;
                            height: 100%;
                            margin-left: 5%;
                            background: url('#{$borderpng}') no-repeat center;
                            background-size: contain;
                            font-size: 0.7rem;
                            padding-left: 17%;
                            padding-top: 6%;
                            color: #fff;
                            box-sizing: border-box;
                            text-align: left;

                            span {
                                margin-right: 5%;
                                margin-left: 5%;
                            }
                        }

                        .cicle {
                            content: '';
                            display: block;
                            position: absolute;
                            width: 1.7rem;
                            height: 1.7rem;
                            background: url('#{$greenpng}') no-repeat center;
                            background-size: 100%;
                            left: 0;
                            bottom: 0;
                        }
                    }
                }
            }
        }

        .total {
            width: 65%;
            height: 100%;
            float: left;
            position: relative;

            .data1,
            .data2,
            .data3,
            .data4 {
                width: 10rem;
                height: 4rem;
                position: absolute;
                opacity: 0;
                animation: dashFadeIn 1s cubic-bezier(0.25, 0.1, 0.25, 1.5) 3.5s forwards;

                span {
                    color: #0ac1c7;
                    font-size: 0.8rem;
                    font-family: '宋体';
                }

                p {
                    font-family: 'LCdd2';
                    font-size: 1.1rem;
                    // color: #f29701;
                    -webkit-animation: maskedAnimation 2s infinite linear;
                    letter-spacing: 0.2rem;
                    background-image: -webkit-linear-gradient(left, #fce66b, #f29701 25%, #fce66b 50%, #f29701 75%, #ffd900);
                    -webkit-text-fill-color: transparent;
                    -webkit-background-clip: text;
                    -webkit-background-size: 200% 100%;

                    &:hover {
                        transform: scale(1.1);
                        transition: all 0.3s;
                        text-shadow: 0 0 5px #ffffff, 0 0 6px #ff9d00;

                        // &::before {
                        //     content: "¥";
                        //     transform: scale(1.2);
                        //     transition: all 0.3s;
                        //     text-shadow: 0 0 5px #ffffff, 0 0 6px #ff9d00;
                        //     font-family: 'LCdd2';
                        //     font-size: 1.5rem;
                        // }
                    }
                }
            }

            .data1 {
                left: 10%;
                top: 12%;
            }

            .data2 {
                left: 37%;
                top: 3%;
            }

            .data3 {
                left: 57%;
                top: 5%;
            }

            .data4 {
                left: 68%;
                top: 28%;
            }

            .dashed {
                position: absolute;
                left: 0;
                top: 0;
                opacity: 0;
                pointer-events: none;
                animation: dashFadeIn 2s cubic-bezier(0.25, 0.1, 0.25, 1.5) 3.1s forwards;
            }

            .sphere {
                width: 20rem;
                height: 20rem;
                position: relative;
                margin: 14% auto 0;

                video {
                    width: 100%;
                    height: 100%;
                    filter: hue-rotate(197deg) saturate(1) brightness(1.7);
                    pointer-events: none;
                    animation: treeHueRouter 3s cubic-bezier(0.25, 0.1, 0.25, 1.5) infinite alternate;
                    animation-delay: 3.1s;
                }

                .sphere-bg {
                    position: absolute;
                    z-index: 100;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    background: url('#{$earthpng53}') no-repeat center;
                    background-size: contain;
                }

                .sum {
                    position: absolute;
                    z-index: 100;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    background: url('#{$cloudpng53}') no-repeat center;
                    background-size: 55%;

                    span {
                        display: block;
                        margin-top: 30%;
                        padding-left: 32%;
                        color: #005a79;
                        font-size: 0.9rem;
                        text-align: left;
                    }

                    p {
                        margin-top: 2%;
                        text-align: center;
                        color: #003c63;
                        font-family: 'LCdd';
                        font-size: 2rem;
                    }
                }
            }

            .cicle3 {
                width: 35rem;
                height: 35rem;
                background: url('#{$circlepng}') no-repeat center;
                background-size: 100%;
                position: absolute;
                // top: 20%;
                top: 24%;
                left: 50%;
                transform-style: preserve-3d;
                transform: translateX(-50%) rotateX(75deg);
                animation: rotate3 20s linear infinite;
                opacity: 0.5;
            }

            .cicle4 {
                width: 15rem;
                height: 15rem;
                position: absolute;
                top: 60%;
                left: 50%;
                transform-style: preserve-3d;
                background: url('#{$gqrightpng53}') no-repeat center;
                background-size: 100%;
                transform: translateX(-50%) rotateX(75deg);
                animation: rotate3 2s linear infinite;
            }

            .cicle5 {
                width: 15rem;
                height: 15rem;
                position: absolute;
                top: 62%;
                left: 50%;
                transform-style: preserve-3d;
                background: url('#{$gqleftpng53}') no-repeat center;
                background-size: 100%;
                transform: translateX(-50%) rotateX(75deg);
                animation: rotate4 2s linear infinite;
            }

            .cicle6 {
                width: 12rem;
                height: 12rem;
                position: absolute;
                top: 70%;
                left: 50%;
                transform-style: preserve-3d;
                background: url('#{$gqbottomright535png}') no-repeat center;
                background-size: 100%;
                transform: translateX(-50%) rotateX(75deg);
                animation: rotate3 2s linear infinite;
            }

            .cicle7 {
                width: 12rem;
                height: 12rem;
                position: absolute;
                top: 72%;
                left: 50%;
                transform-style: preserve-3d;
                background: url('#{$gqbottomleftpng53}') no-repeat center;
                background-size: 100%;
                transform: translateX(-50%) rotateX(75deg);
                animation: rotate4 2s linear infinite;
            }

            .cicle8,
            .cicle9,
            .cicle10,
            .cicle11 {
                width: 4rem;
                height: 4rem;
                position: absolute;
                top: 50%;
                left: 50%;
                z-index: 100;
                margin-left: -2.5rem;
                border-radius: 50%;
                opacity: 0;
                animation: dashFadeIn 1s cubic-bezier(0.25, 0.1, 0.25, 1.5) 3.5s forwards;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                cursor: pointer;

                span {
                    display: block;
                    font-family: 'LCdd';
                    font-size: 0.6rem;
                    text-align: center;
                    cursor: pointer;
                }
            }

            .cicle8 {
                // background: url('#{$circle2png}') no-repeat;
                // background: url('#{$circle2png}') no-repeat;
                background-size: 100%;
                animation: rotate5 20s linear 4s infinite;
                // color: #f29701;
                color: #0ac1c7;
                box-shadow: inset 0px 0px 8px 7px #0ac1c7;
            }

            .cicle9 {
                // background: url('#{$circle2png}') no-repeat;
                background-size: 100%;
                animation: rotate6 20s linear 4s infinite;
                color: #0ac1c7;
                box-shadow: inset 0px 0px 8px 7px #0ac1c7;
            }

            .cicle10 {
                // background: url('#{$circle2png}') no-repeat;
                // background: url('#{$circle2png}') no-repeat;
                background-size: 100%;
                animation: rotate7 20s linear 4s infinite;
                // color: #f29701;
                color: #0ac1c7;
                box-shadow: inset 0px 0px 8px 7px #0ac1c7;
            }

            .cicle11 {
                // background: url('#{$circle2png}') no-repeat;
                background-size: 100%;
                color: #0ac1c7;
                animation: rotate8 20s linear 4s infinite;
                box-shadow: inset 0px 0px 8px 7px #0ac1c7;
            }
        }

        .lineChart {
            width: 27.5%;
            height: 30%;
            position: absolute;
            bottom: 0;
            right: 2.5%;
            display: none;
        }

        .analyse {
            width: 17.5%;
            // height: 70%;
            height: 98%;
            float: left;
            display: flex;
            flex-direction: column;
            animation: panelFadeInFromRight 1s ease-in-out 0s forwards;

            // 改为跳转导航组
            >.websiteMenu {
                flex: 1;
                display: flex;
                flex-direction: column;
                margin-bottom: 1rem;
                width: 110%;
                transform: translateX(-10%);

                >div {
                    flex: 1;
                    display: flex;
                    flex-direction: row;

                    >div {
                        flex: 1;
                        justify-content: center;
                        align-items: center;
                        display: flex;
                        flex-direction: column;
                        font-size: 0.8rem;
                        cursor: pointer;

                        &:hover {
                            background-color: rgba(3, 169, 244, 0.1);
                            backdrop-filter: blur(3px);
                        }

                        >img {
                            width: 1.8rem;
                            padding-bottom: 0.3rem;
                        }

                        >span {
                            white-space: nowrap;
                            writing-mode: horizontal-tb;
                            text-orientation: upright;
                            color: #ffffff;
                            font-weight: bold;
                            background-image: -webkit-linear-gradient(bottom, #00d7ff, #fff);
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                        }
                    }
                }
            }

            >.waterEleIdeaPanel {
                flex: 1;
                display: flex;
                flex-direction: column;
                position: relative;
                width: 110%;
                transform: translateX(-10%);

                // 标题
                >p {
                    background: url(data:image/png;base64,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) no-repeat center;
                    background-size: 100%;
                    color: #fff;
                    text-align: center;
                    display: table;
                    width: 100%;
                    margin: 0px;
                    font-size: 0.9rem;
                    margin-bottom: 0.8rem;
                }

                >.dreamPanel {
                    flex: 1;
                    display: flex;
                    flex-direction: column;

                    >div {
                        flex: 1;
                        font-size: 0.8rem;
                        color: #ffffff;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        border-radius: 0.1rem;
                        background-color: rgba(3, 169, 244, 0.1);
                        backdrop-filter: blur(3px);
                        text-align: left;


                        >.imgLogoPanel {
                            transition: all 0.3s;
                            position: absolute;
                            left: 0.3rem;
                            top: 0px;
                            bottom: 0px;
                            margin: auto;
                            width: 1.2rem;
                            height: auto;
                            background-size: 100% 100%;
                            background-repeat: no-repeat;
                            background-image: url('../assets/imgbk2.svg');

                        }

                        >span {
                            transition: all 0.3s;
                            display: block;
                            width: 100%;
                            text-indent: 1.8rem;
                            font-size: 0.8rem;
                            white-space: nowrap;
                            writing-mode: horizontal-tb;
                            text-orientation: upright;
                            color: #ffffff;
                            font-weight: bold;
                            background-image: -webkit-linear-gradient(bottom, #00d7ff, #fff);
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                        }

                        &::before {
                            opacity: 0;
                            content: "";
                            width: 100%;
                            height: 0.1rem;
                            position: absolute;
                            bottom: 0rem;
                            background-image: -webkit-linear-gradient(left, #43ace6, #43ace678, #43ace600);

                        }

                        // &::after {
                        //     content: "";
                        //     height: 100%;
                        //     width: 0.15rem;
                        //     position: absolute;
                        //     bottom: 0rem;
                        //     right: 0px;
                        //     background-color: #43ace6;
                        // }

                        &:hover {
                            cursor: pointer;
                            background-color: hsla(199, 98%, 48%, 0.2);

                            &::before {
                                transition: all 0.3s;
                                opacity: 1;
                                background-image: -webkit-linear-gradient(left, #ea9700, #ea970078, #ea970000);
                            }

                            &::after {
                                opacity: 0;
                            }

                            >.imgLogoPanel {
                                background-image: url('../assets/imgbk3.svg');
                                width: 1.3rem;
                                left: 0.2rem;
                            }

                            >span {
                                white-space: nowrap;
                                writing-mode: horizontal-tb;
                                text-orientation: upright;
                                color: #ffffff;
                                font-weight: bold;
                                text-indent: 1.8rem;
                                background-image: -webkit-linear-gradient(bottom, #ea9700, #fff);
                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent;
                            }
                        }
                    }
                }

                >.changeButtons {
                    height: 1rem;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    >div {
                        width: 0.5rem;
                        height: 25%;
                        margin: 0px 0.3rem;
                        border: 0.08rem solid rgba(3, 169, 244, 0.4);
                        cursor: pointer;
                        border-radius: 0.2rem;
                        backdrop-filter: blur(3px);
                    }
                }
            }

            .analyse-title {
                width: 100%;
                height: 10%;
                background: url('#{$titlepng}') no-repeat center;
                background-size: 100%;
                color: #fff;
                text-align: center;
                display: table;
                font-size: 0.9rem;

                span {
                    display: table-cell;
                    vertical-align: middle;
                }
            }
        }

        .awardInfoPanel {
            width: 27.5%;
            height: 30%;
            position: absolute;
            bottom: 0;
            left: 2.5%;
            display: flex;
            flex-direction: column;
            padding: 10px;
            z-index: 1;
            animation: panelFadeInFromLeft 1s ease-in-out 0s forwards;
        }
    }

    // 底部模块名称容器
    .bottom {
        width: 100%;
        height: 10%;
        position: relative;
        display: flex;
        animation: panelFadeIn 1s ease-in-out 0s forwards;

        >div {
            flex: 1;
            font-size: 0.8rem;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            margin: 0px 0.5rem 0.5rem 0.5rem;
            background-color: rgba(3, 169, 244, 0.1);
            backdrop-filter: blur(3px);

            >span {
                white-space: nowrap;
                writing-mode: horizontal-tb;
                text-orientation: upright;
                color: #ffffff;
                font-weight: bold;
                background-image: -webkit-linear-gradient(bottom, #00d7ff, #fff);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            &:hover {

                &::after,
                &::before,
                &>.borderPanel::before,
                &>.borderPanel::after {
                    transition: all 0.5s;
                    width: 100%;
                    height: 100%;
                }
            }

            &::after {
                position: absolute;
                top: -0.1rem;
                left: -0.1rem;
                display: block;
                content: "";
                width: 0.5rem;
                height: 0.5rem;
                border-left: 0.1rem solid #a7ebff;
                border-top: 0.1rem solid #a7ebff;
            }

            &::before {
                position: absolute;
                display: block;
                content: "";
                top: -0.1rem;
                right: -0.1rem;
                width: 0.5rem;
                height: 0.5rem;
                border-right: 0.1rem solid #a7ebff;
                border-top: 0.1rem solid #a7ebff;
            }

            >.borderPanel {
                width: 100%;
                height: 100%;
                pointer-events: none;
                position: absolute;

                &::after {
                    position: absolute;
                    bottom: -0.1rem;
                    left: -0.1rem;
                    display: block;
                    width: 0.5rem;
                    height: 0.5rem;
                    content: "";
                    border-left: 0.1rem solid #a7ebff;
                    border-bottom: 0.1rem solid #a7ebff;
                }

                &::before {
                    position: absolute;
                    display: block;
                    content: "";
                    width: 0.5rem;
                    height: 0.5rem;
                    bottom: -0.1rem;
                    right: -0.1rem;
                    border-right: 0.1rem solid #a7ebff;
                    border-bottom: 0.1rem solid #a7ebff;
                }
            }

            >img {
                margin-right: 0.2rem;
                width: 1rem;
            }

            &:hover {
                cursor: pointer;
                // transition: box-shadow 0.3s;
                // box-shadow: 0px 0px 5px 1px #025d75;
                // background: none;
            }
        }

        >h5 {
            background-image: -webkit-linear-gradient(bottom, #86919e, #fff);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            height: 40%;
            display: table;
            margin: auto;

            >span {
                display: table-cell;
                vertical-align: middle;
            }
        }

        >p {
            color: #0ac1c7;
            font-size: 0.6rem;
        }
    }

    // 背景雨滴效果
    .bkRainCanvas {
        position: fixed;
        left: 0;
        top: 0;
        // z-index: -1;
        pointer-events: none;
    }

    // 弹窗容器
    .dialogWindow {
        width: 0px;
        height: 0px;
        overflow: hidden;
        position: fixed;
        top: 0px;
        left: 0px;
        bottom: 0px;
        right: 0px;
        margin: auto;
        backdrop-filter: blur(3px);
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 9999999;
        display: flex;
        justify-content: center;
        align-items: center;


        >.dialogWindowBody {
            width: 70vw;
            height: 70vh;
            border-radius: 0.4rem;
            position: relative;
            display: flex;
            flex-direction: column;

            >.titlePanel {
                margin-bottom: 1rem;
                margin-top: 2rem;
                width: 100%;
                height: auto;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                >svg {
                    width: 80%;
                }

                >p {
                    margin: 0px;
                    width: 100%;
                    font-weight: 600;
                    font-size: 1.3rem;
                    height: 2.3rem;
                    line-height: 2.3rem;
                    // color: #56fefe;
                    background-image: -webkit-linear-gradient(bottom, #00d7ff, #fff);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    white-space: nowrap;
                    writing-mode: horizontal-tb;
                    text-orientation: upright;
                    animation: textShadowInOut 1.5s linear infinite alternate;
                    -webkit-text-stroke: 2px #2e828c;
                    text-shadow: 1px 0 5px #b9f8ff;
                }
            }

            // 整体背景图
            >svg {
                position: absolute;
                top: 0px;
                bottom: 0px;
                right: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
            }

            // 上下图表容器
            >.chartPanelTop,
            >.chartPanelBottom {
                flex: 1;
                display: flex;
                flex-direction: row;

                >div {
                    flex: 1;
                    margin: 0.5rem;
                }
            }

            // 跳转按钮
            >.chartPanelButton {
                height: 10%;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                >span {
                    padding: 10px 20px;
                    background-image: url('../assets//bg02.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    color: #ffffff;
                    font-size: 0.8rem;
                }
            }

            // 跳转平台名称
            .chartPanelWebsiteName {
                height: 10%;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                >span {
                    font-size: 1rem;
                    color: #ffffff;
                    font-weight: bold;
                }
            }

            // 关闭按钮
            >.dialogWindowClose {
                position: absolute;
                bottom: -1.5rem;
                left: 0px;
                right: 0px;
                margin: auto;
                width: 1.5rem;
                height: 1.5rem;
                border-radius: 50%;
                overflow: hidden;
                cursor: pointer;

                >img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    // 多级按钮弹窗
    .btnDialogWindow {
        transition: all 0.5s;
        position: fixed;
        top: 0px;
        bottom: 0px;
        right: 0px;
        left: 0px;
        width: 0px;
        height: 0px;
        margin: auto;
        backdrop-filter: blur(3px);
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 999999;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;

        >.btnDialogBody {
            // 100vw / (8份 / 2份) + 6rem(2份 * 3rem)
            width: calc(100vw / 3 + 6rem);
            height: calc(100vh / 3);
            border-radius: 0.4rem;
            position: relative;
            background-color: #0000;

            >svg {
                width: 100%;
                height: 100%;
            }

            >.btnDialogCloseBtn {
                position: absolute;
                bottom: -1.5rem;
                left: 0px;
                right: 0px;
                margin: auto;
                width: 1.5rem;
                height: 1.5rem;
                border-radius: 50%;
                overflow: hidden;
                cursor: pointer;

                >img {
                    width: 100%;
                    height: 100%;
                }
            }

            >.btnGroupPanel {
                position: absolute;
                left: 0px;
                right: 0px;
                top: 0px;
                bottom: 0px;
                height: 10vh;
                width: calc(100% - 3rem);
                margin: auto;
                // padding: 0 1rem;
                flex-direction: row;
                display: flex;

                >div {
                    flex: 1;
                    font-size: 0.8rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    background-color: rgba(3, 169, 244, 0.1);
                    backdrop-filter: blur(3px);
                    margin: 0px .5rem;

                    >span {
                        white-space: nowrap;
                        writing-mode: horizontal-tb;
                        text-orientation: upright;
                        color: #ffffff;
                        font-weight: bold;
                        background-image: -webkit-linear-gradient(bottom, #00d7ff, #fff);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }

                    &:hover {

                        &::after,
                        &::before,
                        &>.borderPanel::before,
                        &>.borderPanel::after {
                            transition: all 0.5s;
                            width: 100%;
                            height: 100%;
                        }
                    }

                    &::after {
                        position: absolute;
                        top: -0.1rem;
                        left: -0.1rem;
                        display: block;
                        content: "";
                        width: 0.5rem;
                        height: 0.5rem;
                        border-left: 0.1rem solid #a7ebff;
                        border-top: 0.1rem solid #a7ebff;
                    }

                    &::before {
                        position: absolute;
                        display: block;
                        content: "";
                        top: -0.1rem;
                        right: -0.1rem;
                        width: 0.5rem;
                        height: 0.5rem;
                        border-right: 0.1rem solid #a7ebff;
                        border-top: 0.1rem solid #a7ebff;
                    }

                    >.borderPanel {
                        width: 100%;
                        height: 100%;
                        pointer-events: none;
                        position: absolute;

                        &::after {
                            position: absolute;
                            bottom: -0.1rem;
                            left: -0.1rem;
                            display: block;
                            width: 0.5rem;
                            height: 0.5rem;
                            content: "";
                            border-left: 0.1rem solid #a7ebff;
                            border-bottom: 0.1rem solid #a7ebff;
                        }

                        &::before {
                            position: absolute;
                            display: block;
                            content: "";
                            width: 0.5rem;
                            height: 0.5rem;
                            bottom: -0.1rem;
                            right: -0.1rem;
                            border-right: 0.1rem solid #a7ebff;
                            border-bottom: 0.1rem solid #a7ebff;
                        }
                    }

                    >img {
                        margin-right: 0.2rem;
                        width: 1rem;
                    }

                    &:hover {
                        cursor: pointer;
                    }
                }
            }
        }
    }
}
</style>
